var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import dayjs from 'dayjs';
import React from 'react';
import Popover from 'antd/lib/popover';
import { TextComponent, CustomerTextButton, CustomerSegmentContainer, CustomerSegmentContainerInScheduleBlock, Marginer, Rectangle, CustomDropdownMenu, Icon, KRWFomatToString, CheckboxDropdownContent, commonHandleSalesSubmit, ClickableText, syncNaverCalendar, useEntireLoader, BigTitleModal, ScheduleStatusTag, HookFormInputs, ButtonWithPlusCircle, AlertComponent, ColorTag, AntButton, AntPrimaryGhostButton, AntLeftIconButton, handleSubmitHairTag, NaverHairTagForm } from 'renderer/components';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { COLORS } from 'renderer/styles';
import Dropdown from 'antd/lib/dropdown';
import { ScheduleModel, EXTENDED_SALES_METHODS, RESERVATION_STATUS, NAVER_PAY_STATUS } from 'renderer/models';
import { IMAGES } from 'renderer/assets';
import notification from 'antd/lib/notification';
import { CustomerQuery, NaverLambdaQuery, PaymentHistoryQuery, ScheduleQuery, StoreQuery } from 'renderer/queries';
import Radio from 'antd/lib/radio';
import Space from 'antd/lib/space';
import Slider from 'antd/lib/slider';
import { useRecoilState } from 'recoil';
import { Atoms, useSaleModal, useScheduleModal } from 'renderer/stores';
import styled, { css } from 'styled-components';
import { ManagerQuery } from 'renderer/queries';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import Menu from 'antd/lib/menu';
import { gotoNaverBooking, isNumber, sum, omitEmptyValues, isEmpty, floor, isBoolean, flatten, useButtonLock } from 'renderer/utils';
import { Layout } from 'common-ui';
import { DATE_FORMAT_INCLUDE_TIME, DATE_FORMAT_INCLUDE_TIME_AAA } from 'renderer/constants';
import { useForm } from 'react-hook-form';
import Divider from 'antd/lib/divider';
import Collapse from 'antd/lib/collapse';
import { useInView } from 'react-intersection-observer';
import { Spin } from 'antd/lib';
export var LabelWithContent = function (props) {
    return (React.createElement(Row, { gutter: 4, style: __assign({ marginBottom: '5px' }, (props.style || {})) },
        React.createElement(Col, { span: 2 }, props.iconName && React.createElement(Icon, { name: props.iconName, size: 14, color: COLORS.gray4 })),
        React.createElement(Col, { span: 22 }, typeof props.content === 'string' ? (React.createElement(TextComponent, { type: "caption1", color: COLORS.black, style: props.preLine ? { whiteSpace: 'pre-line' } : {} }, props.content)) : (props.content))));
};
var MoreActions = function (props) {
    var _a, _b, _c;
    var actions = [
        { label: '예약금관리', name: 'deposit', disabled: !!((_a = props.schedule) === null || _a === void 0 ? void 0 : _a.salesHistoryId) },
        { label: '예약문자 발송', name: 'message' },
        { label: '등록된 예약보기', name: 'details' },
        ((_b = props.schedule) === null || _b === void 0 ? void 0 : _b.isOfficialNaverReservation) && { label: '네이버 헤어태그 수정', name: 'har-tags' },
        [(ScheduleModel.RESERVATION_STATUS.CONFIRMED, ScheduleModel.RESERVATION_STATUS.COMPLETED)].includes((_c = props.schedule) === null || _c === void 0 ? void 0 : _c.status) && { label: '매출등록', name: 'sales' }
    ]
        .filter(Boolean)
        .map(function (item) {
        return __assign(__assign({}, item), { onClick: function () { return props.onClick(item.name); } });
    });
    return (React.createElement(Dropdown, { trigger: ['click'], overlay: React.createElement(CustomDropdownMenu, { items: actions }), placement: "bottomRight" },
        React.createElement(MarginedIcon, { name: "more-horizontal", color: COLORS.gray2, size: 20 })));
};
export var ScehduleDetailPopoverTitleRow = styled(Row)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px;\n  border-bottom: 1px solid ", ";\n  & svg {\n    margin-right: 10px;\n\n    &:last-child: {\n      margin-right: 0px;\n    }\n  }\n"], ["\n  padding: 10px;\n  border-bottom: 1px solid ", ";\n  & svg {\n    margin-right: 10px;\n\n    &:last-child: {\n      margin-right: 0px;\n    }\n  }\n"])), COLORS.gray6);
var ReservationMeta = function (props) {
    var _a, _b;
    var schedule = props.schedule;
    var isNaver = ((_a = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _a === void 0 ? void 0 : _a.provider) === 'naver';
    var deposit = ((_b = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _b === void 0 ? void 0 : _b.deposit) || 0;
    return (React.createElement(ScehduleDetailPopoverTitleRow, { wrap: true, align: "middle", justify: "start", gutter: 4, onClick: function (event) {
            event.stopPropagation();
            event.preventDefault();
        } },
        React.createElement(Col, null,
            React.createElement(ScheduleStatusTag, { schedule: schedule })),
        React.createElement(Col, null,
            React.createElement(Row, null,
                React.createElement(ScheduleIcon, { type: "provider", schedule: schedule }),
                React.createElement(TextComponent, { children: isNaver ? '네이버' : '직접입력', type: "caption1", marginLeft: 5 }))),
        deposit ? (React.createElement(Col, null,
            React.createElement(Row, null,
                React.createElement(ScheduleIcon, { type: "deposit", schedule: schedule }),
                React.createElement(TextComponent, { children: KRWFomatToString({ value: deposit }), type: "caption1", marginLeft: 5 })))) : (React.createElement("div", null))));
};
var ScheduleTitle = function (props) {
    var schedule = props.schedule;
    if (!schedule) {
        return React.createElement("div", null);
    }
    var store = StoreQuery.getMyStoreInCache();
    var isReservation = (schedule === null || schedule === void 0 ? void 0 : schedule.type) === ScheduleModel.RESERVATION_TYPE.RESERVATION;
    var customer = schedule.customer;
    var isSaled = !!schedule.salesHistoryId;
    var renderActions = function () {
        return (React.createElement(Col, null,
            React.createElement(Row, { align: "top", wrap: false },
                React.createElement(Col, null,
                    React.createElement(MarginedIcon, { name: "edit3", size: 20, color: COLORS.gray2, onClick: function () {
                            props.onClick('update');
                        } })),
                !isSaled && (React.createElement(Col, null,
                    React.createElement(DeleteDiv, { children: React.createElement(MarginedIcon, { name: "trash", color: COLORS.gray2, size: 20 }), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, showDeleteReservationPopup(schedule, store)];
                                    case 1:
                                        _a.sent();
                                        if (props.onCloseModal) {
                                            props.onCloseModal();
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); } }))),
                React.createElement(MoreActions, { schedule: props.schedule, onClick: function (key) {
                        props.onClick(key);
                    } }))));
    };
    var renderTitleRow = function (title) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, { wrap: false, justify: "space-between", gutter: 12 },
                React.createElement(Col, { flex: 1 }, title),
                React.createElement(Col, null, renderActions()))));
    };
    return (React.createElement(ScehduleDetailPopoverTitleRow, { wrap: false, align: "middle", justify: "space-between", onClick: function (event) {
            event.stopPropagation();
            event.preventDefault();
        } }, isReservation ? (React.createElement(Col, { flex: 1 }, customer ? (React.createElement(React.Fragment, null,
        renderTitleRow(React.createElement(CustomerTextButton, { customer: schedule.customer, isDeleted: !!schedule.customerId, onCustomerDetailOpen: props.onCustomerDetailOpen })),
        React.createElement(TextComponent, { children: customer.phoneToString || '', color: COLORS.gray2 }),
        React.createElement(Marginer, { height: 5 }),
        React.createElement(CustomerSegmentContainer, { items: CustomerQuery.getCustomerSegments(schedule.customer) }))) : schedule.customerId ? (renderTitleRow(React.createElement(TextComponent, { children: '삭제된 회원', type: "subtitle1" }))) : (renderTitleRow(React.createElement(TextComponent, { children: '미등록 고객', type: "subtitle1" }))))) : (React.createElement(Col, { flex: 1 }, renderTitleRow(React.createElement(TextComponent, { children: schedule.popoverTitle, type: "subtitle1" }))))));
};
var ScheduleContent = function (props) {
    var schedule = props.schedule;
    var manager = schedule.manager;
    var color = schedule.color;
    var managerName = manager ? (React.createElement(Row, { align: "middle" },
        React.createElement(Rectangle, { color: color.manager, width: 12 }),
        React.createElement(TextComponent, { children: schedule.managerName, type: "caption1", marginLeft: 5 }))) : ('');
    return schedule.type === ScheduleModel.RESERVATION_TYPE.RESERVATION ? (React.createElement(ScheduleContentWrapper, null,
        React.createElement(LabelWithContent, { iconName: "clock", content: React.createElement(TextComponent, { children: schedule.datesToString, type: "caption1" }) }),
        React.createElement(LabelWithContent, { iconName: "gift", content: schedule.displayContent }),
        managerName ? React.createElement(LabelWithContent, { iconName: "users", content: managerName }) : '',
        React.createElement(LabelWithContent, { iconName: "file-text", content: schedule.description || '-', preLine: true, style: { height: '100px', overflowY: 'scroll' } }))) : (React.createElement(ScheduleContentWrapper, null,
        React.createElement(LabelWithContent, { iconName: "clock", content: React.createElement("div", null,
                React.createElement(TextComponent, { children: schedule.datesToString, type: "caption1" }),
                schedule.isRepeatSchedule ? (React.createElement(TextComponent, { children: schedule.repeatString, type: "caption1", color: COLORS.gray3 })) : (React.createElement("div", null))) }),
        managerName ? React.createElement(LabelWithContent, { iconName: "users", content: managerName }) : '',
        !schedule.isMadeFromClient && React.createElement(LabelWithContent, { iconName: "file-text", content: schedule.displayContent || '-' })));
};
var ScheduleContentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 10px;\n"])));
export var ScheduleDetailForModal = function (props) {
    var schedule = props.schedule;
    var add = useScheduleModal().add;
    var saleModal = useSaleModal();
    var handleClick = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(type === 'sales')) return [3 /*break*/, 2];
                    return [4 /*yield*/, schedule.getSalesModalDataFromThis()];
                case 1:
                    data = _a.sent();
                    saleModal.add(data);
                    return [3 /*break*/, 3];
                case 2:
                    add({
                        id: schedule.id,
                        type: type,
                        schedule: schedule
                    });
                    _a.label = 3;
                case 3:
                    if (props.onCloseModal) {
                        props.onCloseModal();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { onClick: function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
        } },
        React.createElement(ScheduleTitle, { schedule: schedule, onClick: handleClick, onCloseModal: props.onCloseModal }),
        schedule.isReservation && React.createElement(ReservationMeta, { schedule: schedule }),
        React.createElement(ScheduleContent, { schedule: schedule }),
        schedule.isOfficialNaverReservation ? (React.createElement(NaverScheduleFooter, { schedule: schedule, onCloseModal: props.onCloseModal, onClick: handleClick })) : (React.createElement(ScheduleFooter, { schedule: schedule, onCloseModal: props.onCloseModal, onClick: handleClick }))));
};
export var NaverScheduleFooter = function (props) {
    var schedule = props.schedule;
    var _a = useRecoilState(Atoms.reservationStatusChangerModalState), _ = _a[0], setScheduleStatusChangerValue = _a[1];
    var store = StoreQuery.getMyStoreInCache();
    var isSaled = !!(schedule === null || schedule === void 0 ? void 0 : schedule.salesHistoryId);
    var handleStatusChangeOpen = function (status) {
        setScheduleStatusChangerValue({ schedule: schedule, status: status, type: 'status' });
        // handleCloseModel();
    };
    var handleOpenHairtag = function () {
        setScheduleStatusChangerValue({ schedule: schedule, type: 'hairtag' });
        // handleCloseModel();
    };
    var handleRequestNaverPostPayment = function (status) {
        setScheduleStatusChangerValue({ schedule: schedule, status: status, type: 'payment' });
        // handleCloseModel();
    };
    var handleClick = function (type) {
        props.onClick(type);
    };
    var handleCloseModel = function () {
        if (props.onCloseModal) {
            props.onCloseModal();
        }
    };
    var renderButtons = function (status) {
        switch (status) {
            case ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR:
            case ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE:
            case ScheduleModel.RESERVATION_STATUS.NOSHOW:
                return schedule.salesHistoryId ? (React.createElement(ViewSalesButton, { onClick: function () { return handleClick('sales'); } })) : (React.createElement(RegisterSalesButtonWithSimple, { store: store, schedule: schedule, onClick: handleClick, onClickCloseModal: handleCloseModel }));
            case ScheduleModel.RESERVATION_STATUS.CONFIRMED:
                return isSaled ? (React.createElement(ViewSalesButton, { onClick: function () { return handleClick('sales'); } })) : (React.createElement(React.Fragment, null,
                    React.createElement(Col, { span: 12 },
                        React.createElement(AntButton, { "$fluid": true, children: "\uC608\uC57D\uCDE8\uC18C", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    handleStatusChangeOpen(ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE);
                                    return [2 /*return*/];
                                });
                            }); } })),
                    React.createElement(Col, { span: 12 },
                        React.createElement(RegisterSalesButtonWithSimple, { store: store, schedule: schedule, onClick: handleClick, onClickCloseModal: handleCloseModel }))));
            case ScheduleModel.RESERVATION_STATUS.COMPLETED:
                return (React.createElement(Col, { span: 24 }, (schedule === null || schedule === void 0 ? void 0 : schedule.salesHistoryId) ? (React.createElement(ViewSalesButton, { onClick: function () { return handleClick('sales'); } })) : (React.createElement(RegisterSalesButtonWithSimple, { store: store, schedule: schedule, onClick: handleClick, onClickCloseModal: handleCloseModel }))));
            default:
                return React.createElement("div", null);
        }
    };
    var renderNaverButtons = function (schedule) {
        var _a, _b;
        var status = schedule.status;
        var availablePostPayment = schedule === null || schedule === void 0 ? void 0 : schedule.naverPostPaymentStatus;
        return (React.createElement(Row, { gutter: 4, style: { marginBottom: '5px' }, wrap: false },
            React.createElement(Col, null,
                React.createElement(AntButton, { shape: "round", children: "\uD5E4\uC5B4\uD0DC\uADF8", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            handleOpenHairtag();
                            return [2 /*return*/];
                        });
                    }); } })),
            status === ScheduleModel.RESERVATION_STATUS.CONFIRMED && (React.createElement(Col, null,
                React.createElement(AntButton, { shape: "round", children: "\uC774\uC6A9\uC644\uB8CC", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            handleStatusChangeOpen(RESERVATION_STATUS.COMPLETED);
                            return [2 /*return*/];
                        });
                    }); } }))),
            !availablePostPayment ? (React.createElement("div", null)) : status === ScheduleModel.RESERVATION_STATUS.CONFIRMED ? (schedule.naverPostPaymentStatus === 'REQUESTED' ? (React.createElement(Col, null,
                React.createElement(AntButton, { shape: "round", danger: true, children: "N-pay\uB9E4\uC7A5\uACB0\uC81C \uC694\uCCAD \uCDE8\uC18C", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            handleRequestNaverPostPayment('CANCELED');
                            return [2 /*return*/];
                        });
                    }); } }))) : (React.createElement(Col, null,
                React.createElement(AntButton, { shape: "round", children: !isBoolean((_a = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _a === void 0 ? void 0 : _a.isPostPaymentSelected)
                        ? 'N-pay매장결제'
                        : ((_b = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _b === void 0 ? void 0 : _b.isPostPaymentSelected)
                            ? 'N-pay매장결제(고객)'
                            : 'N-pay매장결제(상점)', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            handleRequestNaverPostPayment('REQUESTED');
                            return [2 /*return*/];
                        });
                    }); } })))) : // FIXME: 여기 수정 필요
                status === ScheduleModel.RESERVATION_STATUS.COMPLETED ? (React.createElement("div", null)) : (React.createElement("div", null))));
    };
    return (React.createElement("div", null,
        React.createElement(FooterWrapper, null, renderNaverButtons(schedule)),
        React.createElement(FooterWrapper, null, renderButtons(schedule.status))));
};
var REFUND_POLICY;
(function (REFUND_POLICY) {
    REFUND_POLICY["RATE"] = "RATE";
    REFUND_POLICY["ALL"] = "ALL";
    REFUND_POLICY["STANDARD"] = "STANDARD";
    REFUND_POLICY["PRICE"] = "PRICE";
})(REFUND_POLICY || (REFUND_POLICY = {}));
export var ReservationStatusChanger = function (props) {
    var _a;
    var from = ((_a = props.schedule) === null || _a === void 0 ? void 0 : _a.from) || 'crm';
    if (from === 'crm') {
        return React.createElement(ReservationStatusForm, { schedule: props.schedule, status: props.status, store: props.store });
    }
    else if (from === 'naver') {
        if (props.type === 'status') {
            if (props.status === RESERVATION_STATUS.COMPLETED) {
                return React.createElement(NaverBookingCompleteForm, __assign({}, props));
            }
            return React.createElement(NaverBookingStatusForm, __assign({}, props));
        }
        else if (props.type === 'hairtag') {
            return React.createElement(NaverHairTagPopup, { schedule: props.schedule, onClose: props.onClose });
        }
        else {
            return React.createElement(RequestNaverPostPayment, __assign({}, props));
        }
    }
};
var NaverHairTagPopup = function (props) {
    var _a, _b;
    var methods = useForm({ mode: 'onChange' });
    var validate = methods.formState.errors;
    var create = NaverLambdaQuery.useCreateHairTag();
    var update = NaverLambdaQuery.useUpdateTag();
    var bookingId = (_b = (_a = props.schedule) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.idFromProvider;
    var _c = useRecoilState(Atoms.reservationStatusChangerModalState), _ = _c[0], setScheduleStatusChangerValue = _c[1];
    var onSubmit = methods.handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var shouldUpdate, gender, rest, hairTags;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shouldUpdate = values.shouldUpdate, gender = values.gender, rest = __rest(values, ["shouldUpdate", "gender"]);
                    hairTags = flatten(Object.keys(rest)
                        .map(function (key) { return rest[key]; })
                        .filter(Boolean));
                    return [4 /*yield*/, handleSubmitHairTag({ hairTags: hairTags }, shouldUpdate, create, update, bookingId)];
                case 1:
                    _a.sent();
                    setScheduleStatusChangerValue(null);
                    props.onClose();
                    return [2 /*return*/];
            }
        });
    }); }, function (errors) {
        console.log('onSubmit errors', errors);
    });
    var handleClose = function () {
        setScheduleStatusChangerValue(null);
    };
    return (React.createElement(BigTitleModal, { width: 360, title: "\uB124\uC774\uBC84 \uD5E4\uC5B4\uD0DC\uADF8", okButtonProps: {
            disabled: !isEmpty(validate)
        }, zIndex: 999999, centered: true, onCancel: handleClose, onOk: onSubmit, children: React.createElement(NaverHairTagForm, { schedule: props.schedule, form: methods }), open: !!props.schedule }));
};
var RequestNaverPostPayment = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = useRecoilState(Atoms.reservationStatusChangerModalState), _ = _g[0], setScheduleStatusChangerValue = _g[1];
    var handleClose = function () {
        setScheduleStatusChangerValue(null);
        props.onClose && props.onClose();
    };
    if (props.status === 'REFUNDED') {
        return React.createElement(NaverPostPaymentRefunder, __assign({}, props, { onClose: handleClose }));
    }
    React.useEffect(function () {
        var _a, _b;
        var depositItems = (_a = schedule.naverPrePayment) === null || _a === void 0 ? void 0 : _a.items;
        methods.reset({
            items: (_b = schedule.naverPostPaymentItems) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return !item.targetType || item.targetType === 'OPTION'; }),
            uneditableItems: (depositItems === null || depositItems === void 0 ? void 0 : depositItems.map(function (item) {
                if (item.targetType === 'DOWN_PAYMENT') {
                    return __assign(__assign({}, item), { price: -1 * item.price });
                }
                else {
                    return item;
                }
            })) || []
        });
    }, [props.schedule]);
    var schedule = props.schedule, status = props.status;
    var patchPayment = NaverLambdaQuery.usePatchPayment();
    var renderCancel = function () {
        return React.createElement(TextComponent, { children: "\uC694\uCCAD\uD558\uC2E0 \uACB0\uC81C \uC694\uCCAD\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" });
    };
    var methods = useForm({ mode: 'onChange' });
    var values = methods.watch();
    var handleOK = methods.handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var payment, bizItemId, bookingId, paymentId, payload, err_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    payment = (_a = props.schedule) === null || _a === void 0 ? void 0 : _a.naverPostPayment;
                    bizItemId = ((_c = (_b = props.schedule) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.bizItemId) || 171620;
                    bookingId = (_e = (_d = props.schedule) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.idFromProvider;
                    paymentId = payment === null || payment === void 0 ? void 0 : payment.paymentId;
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 4]);
                    payload = {
                        storeId: (_f = props.store) === null || _f === void 0 ? void 0 : _f.id,
                        bizItemId: bizItemId,
                        bookingId: bookingId,
                        paymentId: (payment === null || payment === void 0 ? void 0 : payment.status) === 'REPAYMENT_REQUESTED' && (props === null || props === void 0 ? void 0 : props.status) === 'CANCELED'
                            ? (_g = payment.repayment) === null || _g === void 0 ? void 0 : _g.paymentId
                            : paymentId,
                        scheduleId: (_h = props.schedule) === null || _h === void 0 ? void 0 : _h.id,
                        items: props.status === 'REPAYMENT_REQUESTED' || props.status === 'REQUESTED'
                            ? (_j = values.items) === null || _j === void 0 ? void 0 : _j.concat(values.uneditableItems)
                            : undefined,
                        status: props.status
                    };
                    return [4 /*yield*/, patchPayment.mutateAsync(omitEmptyValues(payload))];
                case 2:
                    _k.sent();
                    notification.info({ message: '요청 성공' });
                    handleClose();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _k.sent();
                    console.log('err', err_1);
                    notification.error({ message: err_1.message || '요청 중 요류 발생' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
    var paymentRequest = function (status) {
        var _a, _b;
        return (React.createElement(NaverPostPaymentContentWraper, null,
            React.createElement(ScheduleCard, { schedule: props.schedule }),
            React.createElement(Layout.FluidInline, { gutter: 8, align: "center", justify: "start", style: { marginTop: '10px', marginBottom: '10px' } },
                React.createElement(TextComponent, { type: "headline3", children: "\uC2DC\uC220\uBA54\uB274\uB0B4\uC5ED", marginTop: 20, marginBottom: 10 })),
            React.createElement(Layout.Stack, { gutter: 8 }, (_a = values.uneditableItems) === null || _a === void 0 ? void 0 :
                _a.map(function (item, index) {
                    return (React.createElement(Layout.FluidInline, { gutter: 8, stretch: 0, align: "center", key: "uneditableItems".concat(index) },
                        React.createElement("div", { style: { padding: '10px' } },
                            React.createElement(TextComponent, { children: item.name })),
                        React.createElement("div", { style: { padding: '10px' } },
                            React.createElement(TextComponent, { children: item.price }))));
                }), (_b = values.items) === null || _b === void 0 ? void 0 :
                _b.map(function (item, index) {
                    var hasType = !!item.targetType;
                    var isFixedItem = hasType && item.targetId;
                    return (React.createElement(Layout.FluidInline, { gutter: 8, stretch: 0, align: "center", key: "items_".concat(index) },
                        isFixedItem ? (React.createElement("div", { style: { padding: '10px' } },
                            React.createElement(TextComponent, { children: item.name }))) : (React.createElement(Layout.FluidInline, { gutter: 8 }, hasType ? (React.createElement(HookFormInputs.SelectInput, { isHorizontal: false, controlProps: {
                                name: "items.".concat(index, ".targetId"),
                                control: methods.control,
                                rules: {
                                    required: { value: true, message: '필수 입력사항입니다.' }
                                }
                            }, inputProps: {
                                style: { width: '100%' },
                                onChange: function (ev) {
                                    var _a;
                                    var option = (_a = naverItems.data) === null || _a === void 0 ? void 0 : _a.options.find(function (option) { return option.optionId === ev; });
                                    methods.setValue("items.".concat(index), {
                                        targetId: option.optionId,
                                        targetType: 'OPTION',
                                        price: option.price || 0,
                                        count: 1,
                                        name: option.name
                                    });
                                },
                                // FIXME: 여기 BizItem에 맞게 나오도록 변경해야됨
                                options: naverOptions
                            } })) : (React.createElement(HookFormInputs.Text, { isHorizontal: false, controlProps: {
                                name: "items.".concat(index, ".name"),
                                control: methods.control,
                                rules: {
                                    required: '필수 입력사항입니다.',
                                    maxLength: { value: 10, message: '10자 이내로 입력해주세요.' }
                                }
                            }, inputProps: {} })))),
                        React.createElement(HookFormInputs.NumberInput, { isHorizontal: false, controlProps: {
                                name: "items.".concat(index, ".price"),
                                control: methods.control,
                                rules: {
                                    required: '필수 입력사항입니다.'
                                }
                            }, inputProps: {
                                allowNegative: !hasType,
                                suffix: '원',
                                style: { width: '150px', marginTop: '5px' }
                            } }),
                        React.createElement(Icon, { name: "close", size: 24, onClick: function () { var _a; return methods.setValue('items', (_a = values === null || values === void 0 ? void 0 : values.items) === null || _a === void 0 ? void 0 : _a.filter(function (_, itemIndex) { return index !== itemIndex; })); } })));
                })),
            React.createElement(Layout.Inline, { gutter: 9, justify: "end", style: { marginTop: '10px' } },
                React.createElement(ButtonWithPlusCircle, { children: "\uC790\uC720 \uD56D\uBAA9 \uCD94\uAC00", onClick: function () { var _a; return methods.setValue('items', (_a = values === null || values === void 0 ? void 0 : values.items) === null || _a === void 0 ? void 0 : _a.concat({ price: 0, count: 1, name: '자유항목' })); } }),
                React.createElement(ButtonWithPlusCircle, { disabled: (naverOptions === null || naverOptions === void 0 ? void 0 : naverOptions.length) === 0, children: "\uC2DC\uC220 \uD56D\uBAA9 \uCD94\uAC00", onClick: function () { var _a; return methods.setValue('items', (_a = values === null || values === void 0 ? void 0 : values.items) === null || _a === void 0 ? void 0 : _a.concat({ price: 0, count: 1, targetType: 'OPTION' })); } })),
            React.createElement(Divider, null),
            React.createElement(Layout.FluidInline, { justify: "end", gutter: 32 },
                React.createElement(TextComponent, { children: "\uCD5C\uC885 \uACB0\uC81C \uC694\uCCAD\uAE08\uC561", type: "headline3", color: COLORS.gray3 }),
                React.createElement(TextComponent, { children: KRWFomatToString({ value: totalPrice }), type: "headline3" })),
            React.createElement(AlertComponent, { style: { marginTop: '20px', marginBottom: '20px' }, message: "\uD83D\uDECE \uC54C\uB824\uB4DC\uB824\uC694", description: React.createElement("div", null,
                    React.createElement(TextComponent, { children: status === 'REQUESTED'
                            ? '⚠️ 고객의 쿠폰 사용여부에 따라 실제 결제금액이 다를 수 있어요.'
                            : '⚠️ 재결제 진행 시 이전에 결제한 예약금은 환불되지 않으며, 매장 방문 결제 금액만 전액 환불됩니다.' })), type: "warning" })));
    };
    var naverItems = NaverLambdaQuery.useNaverItemsWithOptions({ storeId: (_a = props.store) === null || _a === void 0 ? void 0 : _a.id }, { enabled: !!((_b = props.store) === null || _b === void 0 ? void 0 : _b.id) });
    // FIXME: 여기 BizItem에 맞게 나오도록 변경해야됨
    var naverOptions = (_d = (_c = naverItems.data) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.filter(function (option) {
        var _a;
        return !((_a = values.items) === null || _a === void 0 ? void 0 : _a.map(function (item) { return Number(item.targetId); }).includes(option.optionId));
    }).map(function (option) {
        return {
            value: option.optionId,
            label: option.name
        };
    });
    var totalPrice = sum(((_f = (_e = values.items) === null || _e === void 0 ? void 0 : _e.concat(values.uneditableItems || [])) === null || _f === void 0 ? void 0 : _f.map(function (item) { return item.price * item.count; })) || []);
    var objectByStatus = {
        CANCELED: {
            okText: '확인',
            title: '네이버 매장결제 요청취소',
            children: (React.createElement(NaverPostPaymentContentWraper, null, props.status === 'CANCELED' && renderCancel()))
        },
        REQUESTED: {
            okText: '매장결제 요청',
            title: '네이버 매장결제 요청',
            children: paymentRequest(props.status)
        },
        REPAYMENT_REQUESTED: {
            okText: '재결제',
            title: '네이버 매장 재결제 요청',
            children: paymentRequest(props.status)
        },
        REFUNDED_BY_REPAYMENT: {
            okText: '재결제 환불',
            title: '네이버 매장 재결제 환불',
            children: React.createElement(NaverPostPaymentContentWraper, null)
        }
    };
    var item = objectByStatus[props.status];
    var isLoading = patchPayment.isLoading || naverItems.isLoading;
    return (React.createElement(BigTitleModal, { centered: true, open: !!status, onCancel: handleClose, okButtonProps: {
            loading: patchPayment.isLoading,
            disabled: (props.status !== 'CANCELED' && (isEmpty(values) || totalPrice < 0 || !isEmpty(methods.formState.errors))) ||
                isLoading
        }, cancelText: "\uB2EB\uAE30", okText: item.okText, onOk: handleOK, 
        // footer={null}
        title: item.title, children: isLoading ? (React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px', width: '100%' } },
            React.createElement(Spin, null))) : (item.children) }));
};
var NaverPostPaymentRefunder = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var loginedManager = (_a = ManagerQuery.getLoginManagerInCache()) === null || _a === void 0 ? void 0 : _a.id;
    var mutate = ScheduleQuery.useNaverUpdateSchedule();
    var total = (((_c = (_b = props.schedule) === null || _b === void 0 ? void 0 : _b.naverPostPayment) === null || _c === void 0 ? void 0 : _c.amount) || 0) + (((_e = (_d = props.schedule) === null || _d === void 0 ? void 0 : _d.naverPrePayment) === null || _e === void 0 ? void 0 : _e.amount) || 0);
    var handleOK = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bizItems_1, bizItemId, payload, err_2;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!((_a = props.schedule) === null || _a === void 0 ? void 0 : _a.isOfficialNaverReservation)) return [3 /*break*/, 5];
                    bizItems_1 = ((_d = (_c = (_b = props.store) === null || _b === void 0 ? void 0 : _b.preference) === null || _c === void 0 ? void 0 : _c.smartplace) === null || _d === void 0 ? void 0 : _d.bizItems) || {};
                    bizItemId = ((_f = (_e = props.schedule) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.bizItemId) ||
                        Object.keys(bizItems_1).find(function (key) { var _a, _b; return Number((_a = bizItems_1[key]) === null || _a === void 0 ? void 0 : _a.agencyKey) === Number((_b = props.schedule) === null || _b === void 0 ? void 0 : _b.managerId); });
                    if (!bizItemId) {
                        return [2 /*return*/, notification.error({ message: '연결된 직원을 찾을 수 없습니다.' })];
                    }
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, 4, 5]);
                    payload = omitEmptyValues({
                        bizItemId: bizItemId,
                        scheduleId: (_g = props.schedule) === null || _g === void 0 ? void 0 : _g.id,
                        storeId: (_h = props.schedule) === null || _h === void 0 ? void 0 : _h.storeId,
                        bookingId: (_k = (_j = props.schedule) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.idFromProvider,
                        status: 'REFUNDED',
                        refundType: REFUND_POLICY.ALL,
                        refundPrice: total,
                        actorId: loginedManager
                    });
                    return [4 /*yield*/, mutate.mutateAsync(payload)];
                case 2:
                    _l.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _l.sent();
                    return [2 /*return*/, notification.error({
                            message: err_2.message || '네이버 예약 변경에 실패했습니다'
                        })];
                case 4:
                    props.onClose();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(BigTitleModal, { centered: true, open: !!props.status, onCancel: props.onClose, okButtonProps: {
            loading: mutate.isLoading
        }, cancelText: "\uB2EB\uAE30", okText: "\uD658\uBD88", onOk: handleOK, 
        // footer={null}
        title: "\uB124\uC774\uBC84 \uB9E4\uC7A5\uACB0\uC81C \uD658\uBD88", children: React.createElement(NaverPostPaymentContentWraper, null,
            React.createElement(Layout.Stack, { gutter: 8 },
                React.createElement(AlertComponent, { style: { marginTop: '20px', marginBottom: '20px' }, message: "\uD83D\uDECE \uC54C\uB824\uB4DC\uB824\uC694", description: React.createElement("div", null,
                        React.createElement(TextComponent, { children: "\u26A0\uFE0F \uD658\uBD88\uD558\uC5EC\uB3C4 \uC608\uC57D\uC0C1\uD0DC\uB294 \uC644\uB8CC\uC0C1\uD0DC\uB85C \uC720\uC9C0\uB429\uB2C8\uB2E4." }),
                        React.createElement(TextComponent, { children: "\u26A0\uFE0F \uC804\uC561\uD658\uBD88\uB9CC \uAC00\uB2A5\uD569\uB2C8\uB2E4." })), type: "warning" }),
                React.createElement(Layout.Inline, { gutter: 8, justify: "end", align: "center" },
                    React.createElement(TextComponent, { children: "\uC608\uC57D\uAE08 \uACB0\uC81C", color: COLORS.gray3 }),
                    React.createElement(TextComponent, { children: KRWFomatToString({ value: ((_g = (_f = props.schedule) === null || _f === void 0 ? void 0 : _f.naverPrePayment) === null || _g === void 0 ? void 0 : _g.amount) || 0 }), type: "headline3" })),
                React.createElement(Layout.Inline, { gutter: 8, justify: "end", align: "center" },
                    React.createElement(TextComponent, { children: "\uB9E4\uC7A5 \uACB0\uC81C", color: COLORS.gray3 }),
                    React.createElement(TextComponent, { children: KRWFomatToString({ value: ((_j = (_h = props.schedule) === null || _h === void 0 ? void 0 : _h.naverPostPayment) === null || _j === void 0 ? void 0 : _j.amount) || 0 }), type: "headline3" })),
                React.createElement(Layout.Inline, { gutter: 8, justify: "end", align: "center" },
                    React.createElement(TextComponent, { children: "\uD658\uBD88 \uAE08\uC561", color: COLORS.gray3 }),
                    React.createElement(TextComponent, { children: KRWFomatToString({
                            value: total
                        }), type: "headline3" })))) }));
};
var NaverPostPaymentContentWraper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0 20px 20px 20px;\n"], ["\n  padding: 0 20px 20px 20px;\n"])));
var NaverBookingStatusForm = function (props) {
    var _a;
    var _b, _c, _d, _e, _f;
    var schedule = props.schedule;
    var statusFromProps = props.status;
    var _g = useRecoilState(Atoms.reservationStatusChangerModalState), _ = _g[0], setScheduleStatusChangerValue = _g[1];
    var mutate = ScheduleQuery.useNaverUpdateSchedule();
    var loginedManager = (_b = ManagerQuery.getLoginManagerInCache()) === null || _b === void 0 ? void 0 : _b.id;
    var labels = (_a = {},
        _a[RESERVATION_STATUS.NOSHOW] = '노쇼',
        _a[RESERVATION_STATUS.CANCELLED_STORE] = '취소',
        _a);
    var handleClose = function () {
        setScheduleStatusChangerValue(null);
        props.onClose && props.onClose();
    };
    var methods = useForm({ mode: 'onChange' });
    var _h = React.useState(REFUND_POLICY.STANDARD), radioValue = _h[0], setRadioValue = _h[1];
    var _j = React.useState(ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE), statusRadioValue = _j[0], setStatusRadioValue = _j[1];
    var refundPolicy = (_c = props.schedule) === null || _c === void 0 ? void 0 : _c.getNaverRefundPolicy(new Date());
    var values = methods.watch();
    var paidPrice = (((_d = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _d === void 0 ? void 0 : _d.price) || 0) - (((_e = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _e === void 0 ? void 0 : _e.onsitePrice) || 0);
    var shouldShowRefundForm = !!paidPrice && (schedule === null || schedule === void 0 ? void 0 : schedule.isNPayUsed) && statusFromProps !== RESERVATION_STATUS.COMPLETED;
    var refundPrice = radioValue === REFUND_POLICY.ALL
        ? paidPrice
        : radioValue === REFUND_POLICY.STANDARD
            ? (paidPrice * (refundPolicy === null || refundPolicy === void 0 ? void 0 : refundPolicy.rate)) / 100
            : radioValue === REFUND_POLICY.PRICE
                ? values.price || 0
                : (paidPrice * (values.rate || 0)) / 100;
    var shouldShowDescription = statusFromProps !== RESERVATION_STATUS.COMPLETED;
    var label = labels[statusRadioValue];
    var onSubmit = methods.handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var bizItems_2, bizItemId, payload, err_3;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!((_a = props.schedule) === null || _a === void 0 ? void 0 : _a.isOfficialNaverReservation)) return [3 /*break*/, 5];
                    bizItems_2 = ((_d = (_c = (_b = props.store) === null || _b === void 0 ? void 0 : _b.preference) === null || _c === void 0 ? void 0 : _c.smartplace) === null || _d === void 0 ? void 0 : _d.bizItems) || {};
                    bizItemId = ((_f = (_e = props.schedule) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.bizItemId) ||
                        Object.keys(bizItems_2).find(function (key) { var _a, _b; return Number((_a = bizItems_2[key]) === null || _a === void 0 ? void 0 : _a.agencyKey) === Number((_b = props.schedule) === null || _b === void 0 ? void 0 : _b.managerId); });
                    if (!bizItemId) {
                        return [2 /*return*/, notification.error({ message: '연결된 직원을 찾을 수 없습니다.' })];
                    }
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, 4, 5]);
                    payload = omitEmptyValues({
                        bizItemId: bizItemId,
                        scheduleId: (_g = props.schedule) === null || _g === void 0 ? void 0 : _g.id,
                        storeId: (_h = props.schedule) === null || _h === void 0 ? void 0 : _h.storeId,
                        actorId: loginedManager,
                        bookingId: (_k = (_j = props.schedule) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.idFromProvider,
                        status: (statusRadioValue === null || statusRadioValue === void 0 ? void 0 : statusRadioValue.includes('cancel')) ? 'CANCELLED' : statusRadioValue.toUpperCase(),
                        cancelledDesc: (values === null || values === void 0 ? void 0 : values.description) || null,
                        refundType: shouldShowRefundForm ? radioValue : null,
                        refundPrice: shouldShowRefundForm ? refundPrice : null,
                        refundRate: shouldShowRefundForm
                            ? radioValue === REFUND_POLICY.ALL
                                ? 100
                                : radioValue === REFUND_POLICY.STANDARD
                                    ? refundPolicy.rate
                                    : radioValue === REFUND_POLICY.PRICE
                                        ? floor((refundPrice / paidPrice) * 100)
                                        : (values === null || values === void 0 ? void 0 : values.rate) || 0
                            : null
                    });
                    return [4 /*yield*/, mutate.mutateAsync(payload)];
                case 2:
                    _l.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _l.sent();
                    return [2 /*return*/, notification.error({
                            message: err_3.message || '네이버 예약 변경에 실패했습니다'
                        })];
                case 4:
                    handleClose();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); });
    var refundForm = function () {
        return (React.createElement("form", { style: { marginTop: '20px' } },
            shouldShowRefundForm && (React.createElement(Radio.Group, { value: radioValue, style: { width: '100%' }, onChange: function (e) {
                    setRadioValue(e.target.value);
                    methods.setValue('price', null);
                    methods.setValue('rate', null);
                    methods.setFocus(e.target.value, { shouldSelect: true });
                } },
                React.createElement(RefundInputRow, null,
                    React.createElement(Radio, { value: REFUND_POLICY.ALL }, "\uC804\uC561\uD658\uBD88")),
                React.createElement(RefundInputRow, null,
                    React.createElement(Radio, { value: REFUND_POLICY.STANDARD }, "\uB3D9\uC758\uB41C \uD658\uBD88\uAE30\uC900"),
                    React.createElement(TextComponent, null, refundPolicy === null || refundPolicy === void 0 ? void 0 : refundPolicy.message)),
                React.createElement(RefundInputRow, null,
                    React.createElement(Radio, { value: REFUND_POLICY.PRICE }, "\uC815\uC561 \uD658\uBD88"),
                    React.createElement(HookFormInputs.NumberInput, { controlProps: {
                            name: 'price',
                            control: methods.control,
                            rules: {
                                max: {
                                    value: paidPrice,
                                    message: "".concat(KRWFomatToString({ value: paidPrice }), " \uC774\uD558\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694")
                                }
                            }
                        }, inputProps: {
                            style: { width: '100%', marginTop: '5px' },
                            disabled: radioValue !== REFUND_POLICY.PRICE,
                            suffix: '원'
                        } })),
                React.createElement(RefundInputRow, null,
                    React.createElement(Radio, { value: REFUND_POLICY.RATE }, "\uC815\uB960 \uD658\uBD88"),
                    React.createElement(HookFormInputs.NumberInput, { controlProps: {
                            name: "rate",
                            control: methods.control,
                            rules: {
                                max: {
                                    value: 100,
                                    message: '100% 이하로 입력해주세요'
                                }
                            }
                        }, inputProps: {
                            style: { width: '100%', marginTop: '5px' },
                            disabled: radioValue !== REFUND_POLICY.RATE,
                            suffix: '원'
                        } })),
                React.createElement(Row, { style: { width: '100%' }, justify: "space-between" },
                    React.createElement(TextComponent, null, "\uACB0\uC81C \uAE08\uC561"),
                    React.createElement(TextComponent, null, KRWFomatToString({ value: paidPrice }))),
                React.createElement(Row, { style: { width: '100%' }, justify: "space-between" },
                    React.createElement(TextComponent, null, "\uD658\uBD88 \uAE08\uC561"),
                    React.createElement(TextComponent, null, KRWFomatToString({ value: refundPrice }))),
                React.createElement(Row, { style: { width: '100%' }, justify: "space-between" },
                    React.createElement(TextComponent, null, "\uCDE8\uC18C \uC218\uC218\uB8CC"),
                    React.createElement(TextComponent, null, KRWFomatToString({ value: paidPrice - refundPrice }))))),
            shouldShowDescription && (React.createElement(RefundInputRow, null,
                React.createElement(HookFormInputs.Textarea, { controlProps: {
                        name: "description",
                        control: methods.control,
                        rules: {
                            required: '사유를 입력해주세요.'
                        }
                    }, inputProps: {
                        placeholder: statusRadioValue === RESERVATION_STATUS.NOSHOW
                            ? '고객에게 안내할 노쇼 안내를 필수로 입력해 주세요. '
                            : '사유를 입력해주세요.',
                        style: { marginTop: '10px' }
                    } })))));
    };
    // const [, forceUpdate] = React.useReducer((x) => x + 1, 0);
    React.useEffect(function () {
        methods.setValue('description', statusRadioValue === RESERVATION_STATUS.NOSHOW
            ? '예약하신 시간에 방문하지 못해 취소되었습니다. 다시 뵙기를 기대하며 예약 후 방문이 어려우시면 사전에 취소 부탁드립니다.'
            : null);
        // forceUpdate();
    }, [statusRadioValue]);
    return (React.createElement(BigTitleModal, { centered: true, width: 360, open: !!statusRadioValue, onCancel: handleClose, okButtonProps: { loading: mutate.isLoading, disabled: !isEmpty((_f = methods.formState) === null || _f === void 0 ? void 0 : _f.errors) }, cancelText: "\uB2EB\uAE30", okText: "".concat(label, " \uCC98\uB9AC"), onOk: onSubmit, 
        // footer={null}
        title: "\uB124\uC774\uBC84 \uC608\uC57D ".concat(label), children: React.createElement("div", { style: { padding: '0 20px 20px 20px' } },
            React.createElement(ScheduleCard, { schedule: props.schedule }),
            shouldShowDescription && (React.createElement(React.Fragment, null,
                React.createElement(StyledRadioGroup, { value: statusRadioValue, style: { width: '100%' }, onChange: function (e) {
                        setStatusRadioValue(e.target.value);
                    } },
                    React.createElement(Radio, { value: ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE }, "\uC608\uC57D\uCDE8\uC18C"),
                    React.createElement(Radio, { value: ScheduleModel.RESERVATION_STATUS.NOSHOW }, "\uB178\uC1FC")),
                React.createElement(Divider, { style: { marginTop: '8px', marginBottom: '8px' } }))),
            refundForm(),
            React.createElement(TextComponent, { children: "\uB124\uC774\uBC84 \uC608\uC57D\uC744 ".concat(label, " \uCC98\uB9AC\uD569\uB2C8\uB2E4."), type: "caption1", color: COLORS.gray1 }),
            React.createElement(TextComponent, { type: "caption1", color: COLORS.gray1, children: "\uB124\uC774\uBC84\uC5D0 \uBC18\uC601\uB418\uBA70 \uACE0\uAC1D\uC5D0\uAC8C \uC804\uB2EC\uB418\uC5B4 \uB2E4\uC2DC \uC218\uC815\uD558\uC2E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC9C4\uD589\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" })) }));
};
var NaverBookingCompleteForm = function (props) {
    var _a;
    var statusFromProps = props.status;
    var _b = useRecoilState(Atoms.reservationStatusChangerModalState), _ = _b[0], setScheduleStatusChangerValue = _b[1];
    var mutate = ScheduleQuery.useNaverUpdateSchedule();
    var loginedManager = (_a = ManagerQuery.getLoginManagerInCache()) === null || _a === void 0 ? void 0 : _a.id;
    var handleClose = function () {
        setScheduleStatusChangerValue(null);
        props.onClose && props.onClose();
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bizItems_3, bizItemId, payload, err_4;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!((_a = props.schedule) === null || _a === void 0 ? void 0 : _a.isOfficialNaverReservation)) return [3 /*break*/, 5];
                    bizItems_3 = ((_d = (_c = (_b = props.store) === null || _b === void 0 ? void 0 : _b.preference) === null || _c === void 0 ? void 0 : _c.smartplace) === null || _d === void 0 ? void 0 : _d.bizItems) || {};
                    bizItemId = ((_f = (_e = props.schedule) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.bizItemId) ||
                        Object.keys(bizItems_3).find(function (key) { var _a, _b; return Number((_a = bizItems_3[key]) === null || _a === void 0 ? void 0 : _a.agencyKey) === Number((_b = props.schedule) === null || _b === void 0 ? void 0 : _b.managerId); });
                    if (!bizItemId) {
                        return [2 /*return*/, notification.error({ message: '연결된 직원을 찾을 수 없습니다.' })];
                    }
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, 4, 5]);
                    payload = omitEmptyValues({
                        bizItemId: bizItemId,
                        scheduleId: (_g = props.schedule) === null || _g === void 0 ? void 0 : _g.id,
                        storeId: (_h = props.schedule) === null || _h === void 0 ? void 0 : _h.storeId,
                        actorId: loginedManager,
                        bookingId: (_k = (_j = props.schedule) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.idFromProvider,
                        status: 'COMPLETED'
                    });
                    return [4 /*yield*/, mutate.mutateAsync(payload)];
                case 2:
                    _l.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_4 = _l.sent();
                    return [2 /*return*/, notification.error({
                            message: err_4.message || '네이버 예약 이용완료에 실패했습니다'
                        })];
                case 4:
                    handleClose();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(BigTitleModal, { centered: true, width: 360, open: !!statusFromProps, onCancel: handleClose, okButtonProps: { loading: mutate.isLoading }, cancelText: "\uB2EB\uAE30", okText: "\uC774\uC6A9\uC644\uB8CC \uCC98\uB9AC", onOk: onSubmit, title: "\uB124\uC774\uBC84 \uC608\uC57D \uC774\uC6A9\uC644\uB8CC", children: React.createElement("div", { style: { padding: '0 20px 20px 20px' } },
            React.createElement(ScheduleCard, { schedule: props.schedule }),
            React.createElement(TextComponent, { children: "\uB124\uC774\uBC84 \uC608\uC57D\uC744 \uC774\uC6A9\uC644\uB8CC \uCC98\uB9AC\uD569\uB2C8\uB2E4.", type: "caption1", color: COLORS.gray1 }),
            React.createElement(TextComponent, { type: "caption1", color: COLORS.gray1, children: "\uB124\uC774\uBC84\uC5D0 \uBC18\uC601\uB418\uBA70 \uACE0\uAC1D\uC5D0\uAC8C \uC804\uB2EC\uB418\uC5B4 \uB2E4\uC2DC \uC218\uC815\uD558\uC2E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC9C4\uD589\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" })) }));
};
var StyledRadioGroup = styled(Radio.Group)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 20px;\n"], ["\n  margin-top: 20px;\n"])));
var ReservationStatusForm = function (props) {
    var _a;
    var schedule = props.schedule, status = props.status;
    var _b = useRecoilState(Atoms.reservationStatusChangerModalState), _ = _b[0], setScheduleStatusChangerValue = _b[1];
    var mutate = ScheduleQuery.useNaverUpdateSchedule();
    var methods = useForm({ mode: 'onChange' });
    var _c = React.useState(ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR), radioValue = _c[0], setRadioValue = _c[1];
    var updateFunc = ScheduleQuery.useUpdateSchedule();
    var deleteFunc = ScheduleQuery.useDeleteSchedule();
    var onSubmit = methods.handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var shouldBlockNaver, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 5, , 6]);
                    if (!(radioValue === 'delete')) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteFunc.mutateAsync({ storeId: schedule.storeId, id: schedule.id })];
                case 1:
                    _e.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, updateFunc.mutateAsync(__assign(__assign({}, schedule), { status: radioValue, storeId: schedule.storeId }))];
                case 3:
                    _e.sent();
                    _e.label = 4;
                case 4:
                    shouldBlockNaver = (_d = (_c = (_b = props.store.preference) === null || _b === void 0 ? void 0 : _b.smartplace) === null || _c === void 0 ? void 0 : _c.blockSettings) === null || _d === void 0 ? void 0 : _d.isActive;
                    if (shouldBlockNaver) {
                        syncNaverCalendar({ effectedDates: [schedule.dateOption.startedAt], store: props.store });
                    }
                    setScheduleStatusChangerValue(null);
                    return [3 /*break*/, 6];
                case 5:
                    _a = _e.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); });
    var handleClose = function () {
        setScheduleStatusChangerValue(null);
    };
    var refundForm = function () {
        return (React.createElement("form", { style: { marginTop: '20px', marginBottom: '8px' } },
            React.createElement(Radio.Group, { value: radioValue, style: { width: '100%' }, onChange: function (e) {
                    setRadioValue(e.target.value);
                } },
                React.createElement(Radio, { value: ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR }, "\uACE0\uAC1D\uCDE8\uC18C"),
                React.createElement(Radio, { value: ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE }, "\uC0C1\uC810\uCDE8\uC18C"),
                React.createElement(Radio, { value: ScheduleModel.RESERVATION_STATUS.NOSHOW }, "\uB178\uC1FC"),
                React.createElement(Radio, { value: 'delete' }, "\uC0AD\uC81C"))));
    };
    return (React.createElement(BigTitleModal, { centered: true, open: !!status, onCancel: handleClose, okButtonProps: { loading: mutate.isLoading, disabled: !isEmpty((_a = methods.formState) === null || _a === void 0 ? void 0 : _a.errors) }, cancelText: "\uB2EB\uAE30", okText: "\uC608\uC57D \uCDE8\uC18C", onOk: onSubmit, 
        // footer={null}
        title: "\uD305\uCEE4\uBDF0\uC608\uC57D \uCDE8\uC18C", children: React.createElement("div", { style: { padding: '0 20px 20px 20px' } },
            React.createElement(ScheduleCard, { schedule: props.schedule }),
            refundForm(),
            React.createElement(TextComponent, { children: "\uCDE8\uC18C, \uB178\uC1FC\uB294 \uB2EC\uB825\uACFC \uC608\uC57D\uBAA9\uB85D\uC5D0\uC11C \uD655\uC778 \uAC00\uB2A5\uD569\uB2C8\uB2E4.", type: "caption1", color: COLORS.gray1 }),
            React.createElement(TextComponent, { children: "\uC0AD\uC81C\uD558\uC2E4 \uACBD\uC6B0 \uBCF5\uAD6C\uD560\uC218 \uC5C6\uC2B5\uB2C8\uB2E4.", type: "caption1", color: COLORS.gray1 })) }));
};
var RefundInputRow = styled(Row)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  width: 100%;\n"], ["\n  margin-bottom: 10px;\n  width: 100%;\n"])));
export var NPayButton = function (props) {
    return (React.createElement(NaverButtonWrapper, { onClick: props.onClick, "$color": props.color, type: props.type || 'primary', children: React.createElement(Row, { align: "middle", justify: "center" },
            React.createElement(NPayIcon, null),
            React.createElement(TextComponent, { children: props.label || '매장결제', color: COLORS.white, type: "body2" })) }));
};
// background-image: ${(props) =>
//   props.color === 'primary' ? 'linear-gradient(91deg, #01d660 0%, #4bcdcc 144%);' : 'unset'}
var NaverButtonWrapper = styled(Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  border: solid 1px rgba(0, 0, 0, 0.03);\n  &:hover {\n    border: solid 1px rgba(0, 0, 0, 0.03);\n    background-color: ", " !important;\n  }\n"], ["\n  width: 100%;\n  background-color: ", ";\n  border: solid 1px rgba(0, 0, 0, 0.03);\n  &:hover {\n    border: solid 1px rgba(0, 0, 0, 0.03);\n    background-color: ", " !important;\n  }\n"])), function (props) { return (!props.$color ? '#01d660' : props.$color); }, function (props) { return (!props.$color ? '#01d660' : props.$color); });
var NPayIcon = styled.i(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: inline-block;\n  width: 47px;\n  height: 19px;\n  margin-right: 3px;\n  background: url(data:image/png;base64,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)\n    no-repeat 0 0;\n  background-size: 47px 19px;\n  vertical-align: -5px;\n"], ["\n  display: inline-block;\n  width: 47px;\n  height: 19px;\n  margin-right: 3px;\n  background: url(data:image/png;base64,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)\n    no-repeat 0 0;\n  background-size: 47px 19px;\n  vertical-align: -5px;\n"])));
export var ScheduleFooter = function (props) {
    var schedule = props.schedule;
    var store = StoreQuery.getMyStoreInCache();
    var handleModalClose = function () {
        if (props.onCloseModal) {
            props.onCloseModal();
        }
    };
    var updateFunc = ScheduleQuery.useUpdateSchedule();
    var isExternal = schedule.isExternal;
    var handleClick = function (type, schedule) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            props.onClick(type);
            return [2 /*return*/];
        });
    }); };
    var _a = useRecoilState(Atoms.reservationStatusChangerModalState), _ = _a[0], setScheduleStatusChangerValue = _a[1];
    var handleStatusUpdate = function (schedule) { return __awaiter(void 0, void 0, void 0, function () {
        var shouldBlockNaver, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (schedule.status === ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR) {
                        handleModalClose();
                        return [2 /*return*/, setScheduleStatusChangerValue({ schedule: schedule, status: schedule.status, type: 'status' })];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateFunc.mutateAsync(schedule)];
                case 2:
                    _e.sent();
                    shouldBlockNaver = (_d = (_c = (_b = store.preference) === null || _b === void 0 ? void 0 : _b.smartplace) === null || _c === void 0 ? void 0 : _c.blockSettings) === null || _d === void 0 ? void 0 : _d.isActive;
                    if (shouldBlockNaver) {
                        syncNaverCalendar({ effectedDates: [schedule.dateOption.startedAt], store: store });
                    }
                    handleModalClose();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _e.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var renderButton = function () {
        var status = schedule.status;
        if (!schedule.isReservation) {
            return React.createElement("div", null);
        }
        if (isExternal) {
            // TODO: 삭제
            if (status === ScheduleModel.RESERVATION_STATUS.CONFIRMED) {
                return (React.createElement(Row, { gutter: 4, align: "middle", style: { marginRight: '5px' } },
                    React.createElement(Col, null,
                        React.createElement(AntPrimaryGhostButton, { children: "\uB124\uC774\uBC84\uB85C \uC774\uB3D9", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    gotoNaverBooking(store, props.schedule);
                                    return [2 /*return*/];
                                });
                            }); } })),
                    React.createElement(Col, null, schedule.salesHistoryId ? (React.createElement(ViewSalesButton, { onClick: function () { return handleClick('sales', schedule); } })) : (React.createElement(RegisterSalesButtonWithSimple, { store: store, schedule: schedule, onClick: handleClick, onClickCloseModal: handleModalClose })))));
            }
            else {
                return (React.createElement(AntPrimaryGhostButton, { children: "\uB124\uC774\uBC84\uB85C \uC774\uB3D9", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            gotoNaverBooking(store, props.schedule);
                            return [2 /*return*/];
                        });
                    }); } }));
            }
        }
        switch (status) {
            case ScheduleModel.RESERVATION_STATUS.PENDING:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Col, { flex: 1 },
                        React.createElement(AntButton, { "$fluid": true, children: "\uC608\uC57D\uAC70\uC808", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, handleStatusUpdate(__assign(__assign({}, schedule), { status: ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } })),
                    React.createElement(Col, { flex: 1 },
                        React.createElement(AntButton, { "$fluid": true, children: "\uC608\uC57D\uC2B9\uC778", type: "primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, handleStatusUpdate(__assign(__assign({}, schedule), { status: ScheduleModel.RESERVATION_STATUS.CONFIRMED }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }))));
            case ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR:
            case ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE:
            case ScheduleModel.RESERVATION_STATUS.NOSHOW:
                var isCancelableNoshow = !schedule.salesHistoryId && schedule.status === ScheduleModel.RESERVATION_STATUS.NOSHOW;
                return (React.createElement(React.Fragment, null,
                    isCancelableNoshow && (React.createElement(Col, { flex: 1 },
                        React.createElement(AntPrimaryGhostButton, { "$fluid": true, children: "\uB178\uC1FC\uCDE8\uC18C", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, handleStatusUpdate(__assign(__assign({}, schedule), { status: ScheduleModel.RESERVATION_STATUS.CONFIRMED }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }))),
                    React.createElement(Col, { flex: 1 }, schedule.salesHistoryId ? (React.createElement(ViewSalesButton, { onClick: function () { return handleClick('sales', schedule); } })) : (React.createElement(RegisterSalesButtonWithSimple, { store: store, schedule: schedule, onClick: handleClick, onClickCloseModal: handleModalClose })))));
            case ScheduleModel.RESERVATION_STATUS.CONFIRMED:
                return schedule.salesHistoryId ? (React.createElement(ViewSalesButton, { onClick: function () { return handleClick('sales', schedule); } })) : (React.createElement(React.Fragment, null,
                    React.createElement(Col, { span: 12 },
                        React.createElement(AntButton, { "$fluid": true, children: "\uC608\uC57D\uCDE8\uC18C", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, handleStatusUpdate(__assign(__assign({}, schedule), { status: ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR }))];
                                        case 1:
                                            _a.sent();
                                            handleModalClose();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } })),
                    React.createElement(Col, { span: 12 },
                        React.createElement(RegisterSalesButtonWithSimple, { store: store, schedule: schedule, onClick: handleClick, onClickCloseModal: handleModalClose }))));
        }
    };
    return (React.createElement(FooterWrapper, null, props.schedule.type !== ScheduleModel.RESERVATION_TYPE.SCHEDULE && renderButton()));
};
var FooterWrapper = styled(Row).attrs({ align: 'middle', justify: 'space-between', gutter: 4 })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding: 0px 8px;\n  &:last-child {\n    padding-bottom: 8px;\n  }\n"], ["\n  padding: 0px 8px;\n  &:last-child {\n    padding-bottom: 8px;\n  }\n"])));
var RegisterSalesButtonWithSimple = function (props) {
    var _a, _b, _c, _d;
    var store = props.store;
    var schedule = props.schedule;
    var salesData = schedule.createSalesModalDataFromThis();
    var totalPrice = sum((_a = salesData.usingHistory) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.price || 0; })) || 0;
    var depositSum = ((_b = schedule.data) === null || _b === void 0 ? void 0 : _b.methods)
        ? sum(Object.keys((_c = schedule.data) === null || _c === void 0 ? void 0 : _c.methods).map(function (method) { var _a; return ((_a = schedule.data) === null || _a === void 0 ? void 0 : _a.methods[method]) || 0; }))
        : 0;
    var shouldPaid = totalPrice - depositSum;
    var createSales = PaymentHistoryQuery.useCreateSales();
    var loader = useEntireLoader();
    var availableQuick = shouldPaid >= 0 && ((_d = salesData.usingHistory) === null || _d === void 0 ? void 0 : _d.length) > 0;
    var _e = useButtonLock(), isLocked = _e[0], lockButton = _e[1];
    var handleClick = function (key, schedule) {
        lockButton();
        if (!isLocked) {
            props.onClick(key, schedule);
        }
    };
    return availableQuick ? (React.createElement(StyledButtonDropdown, { trigger: ['click'], onClick: function () { return handleClick('sales', schedule); }, icon: React.createElement("img", { src: IMAGES.icon_quick_pay }), dropdownRender: function () { return (React.createElement(Menu, { onClick: function (ev) { return __awaiter(void 0, void 0, void 0, function () {
                var key, methods, sales, err_5;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            key = ev.key;
                            methods = salesData.methods || {};
                            methods[key] = {
                                active: true,
                                deduction: (((_a = methods[key]) === null || _a === void 0 ? void 0 : _a.deduction) || 0) + shouldPaid
                            };
                            sales = __assign(__assign({}, salesData), { methods: methods });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            loader.show();
                            return [4 /*yield*/, commonHandleSalesSubmit(sales, {
                                    drawer: {
                                        type: 'product',
                                        data: sales
                                    },
                                    storeId: schedule.storeId,
                                    createPaymentHistory: createSales.mutateAsync
                                })];
                        case 2:
                            _b.sent();
                            notification.success({ message: '매출 등록이 완료되었습니다.' });
                            return [3 /*break*/, 5];
                        case 3:
                            err_5 = _b.sent();
                            notification.error({ message: err_5.message });
                            return [3 /*break*/, 5];
                        case 4:
                            loader.hide();
                            return [7 /*endfinally*/];
                        case 5:
                            props.onClickCloseModal();
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("div", { style: { padding: '10px' } },
                React.createElement(TextComponent, { type: "headline3", color: COLORS.primary1, children: "\uACB0\uC81C : ".concat(KRWFomatToString({ value: shouldPaid })) }),
                depositSum ? (React.createElement(TextComponent, { children: "\uC0C1\uD488 \uCD1D\uC561 : ".concat(KRWFomatToString({ value: totalPrice })) })) : (React.createElement("div", null)),
                depositSum ? React.createElement(TextComponent, { children: "\uC608\uC57D\uAE08 : ".concat(KRWFomatToString({ value: depositSum })) }) : React.createElement("div", null)),
            [
                EXTENDED_SALES_METHODS.PREPAID_POINT,
                EXTENDED_SALES_METHODS.CUSTOMER_POINT,
                EXTENDED_SALES_METHODS.CARD,
                EXTENDED_SALES_METHODS.TRANSFER,
                EXTENDED_SALES_METHODS.CASH,
                EXTENDED_SALES_METHODS.NAVER_PAY,
                EXTENDED_SALES_METHODS.ETC1,
                EXTENDED_SALES_METHODS.ETC2,
                EXTENDED_SALES_METHODS.ETC3,
                EXTENDED_SALES_METHODS.ETC4,
                EXTENDED_SALES_METHODS.ETC5,
                EXTENDED_SALES_METHODS.UNPAID
            ]
                .map(function (key) {
                var _a, _b, _c;
                if (!((_a = store.paymentMethods[key]) === null || _a === void 0 ? void 0 : _a.active)) {
                    return;
                }
                return {
                    key: key,
                    name: (_b = store.paymentMethods[key]) === null || _b === void 0 ? void 0 : _b.name,
                    active: (_c = store.paymentMethods[key]) === null || _c === void 0 ? void 0 : _c.active
                };
            })
                .filter(Boolean)
                .map(function (item) {
                var _a, _b, _c, _d;
                var removedKeys = [EXTENDED_SALES_METHODS.DISCOUNT, EXTENDED_SALES_METHODS.DEDUCTION_PRICE_BY_TICKET];
                if (removedKeys.includes(item.key)) {
                    return;
                }
                var isPoint = [EXTENDED_SALES_METHODS.PREPAID_POINT, EXTENDED_SALES_METHODS.CUSTOMER_POINT].includes(item.key);
                if (isPoint) {
                    var availablePoint = isPoint && item.key === EXTENDED_SALES_METHODS.PREPAID_POINT
                        ? ((_b = (_a = schedule === null || schedule === void 0 ? void 0 : schedule.customer) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.prepaid) || 0
                        : ((_d = (_c = schedule === null || schedule === void 0 ? void 0 : schedule.customer) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.customerPoint) || 0;
                    var disabled = availablePoint < shouldPaid;
                    return (React.createElement(Menu.Item, { disabled: disabled, key: item.key }, "".concat(item.name, "(\uC794\uC5EC : ").concat(KRWFomatToString({
                        value: availablePoint
                    }), ")")));
                }
                else {
                    return React.createElement(Menu.Item, { key: item.key }, item.name);
                }
            })
                .filter(Boolean))); }, type: "primary" }, "\uB9E4\uCD9C \uB4F1\uB85D")) : (React.createElement(AntButton, { "$fluid": true, type: "primary", children: "\uB9E4\uCD9C \uB4F1\uB85D", onClick: function () {
            handleClick('sales', schedule);
        } }));
};
var StyledButtonDropdown = styled(Dropdown.Button)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  & > button:first-child {\n    width: 100%;\n  }\n"], ["\n  width: 100%;\n  & > button:first-child {\n    width: 100%;\n  }\n"])));
export var showDeleteReservationPopup = function (schedule, store) {
    var _a, _b;
    var typeLabel = schedule.typeString;
    var shouldBlockNaver = (_b = (_a = store.preference.smartplace) === null || _a === void 0 ? void 0 : _a.blockSettings) === null || _b === void 0 ? void 0 : _b.isActive;
    if (schedule.isExternal) {
        return new Promise(function (resolve) {
            Modal.confirm({
                centered: true,
                title: "\uC608\uC57D \uC0AD\uC81C",
                closable: true,
                zIndex: 9999,
                okText: '삭제',
                onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var err_6;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, 3, 4]);
                                return [4 /*yield*/, ScheduleQuery.updateOrDeleteSchedule(__assign(__assign({}, schedule), { status: 'delete' }))];
                            case 1:
                                _a.sent();
                                notification.success({ message: '예약이 삭제되었습니다.' });
                                return [3 /*break*/, 4];
                            case 2:
                                err_6 = _a.sent();
                                notification.error({ message: '예약을 삭제하는 중 오류가 발생했습니다.' });
                                return [3 /*break*/, 4];
                            case 3:
                                if (shouldBlockNaver) {
                                    syncNaverCalendar({
                                        store: store,
                                        effectedDates: [schedule.dateOption.startedAt]
                                    });
                                }
                                resolve(true);
                                return [7 /*endfinally*/];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); },
                cancelText: '아니요',
                content: (React.createElement("div", null,
                    React.createElement(TextComponent, { children: "\uC0AD\uC81C\uD558\uC2E4 \uACBD\uC6B0 \uBCF5\uAD6C\uD558\uC2E4 \uC218 \uC5C6\uC73C\uBA70, \uB2E4\uC2DC \uC218\uC9D1\uD574\uC624\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.(\uB124\uC774\uBC84 \uAD00\uB9AC\uC790\uD398\uC774\uC9C0\uC758 \uC608\uC57D\uC740 \uADF8\uB300\uB85C \uC720\uC9C0\uB429\uB2C8\uB2E4)", marginTop: 20, marginBottom: 5 })))
            });
        });
    }
    var radioValue = 'only';
    return new Promise(function (resolve) {
        var deleteOrUpdate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
            var isOriginSchedule, origin, newSchedule, err_7;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        _m.trys.push([0, 6, 7, 8]);
                        if (!(((_a = schedule.dateOption) === null || _a === void 0 ? void 0 : _a.repeat) && !schedule.isReservation)) return [3 /*break*/, 3];
                        isOriginSchedule = isNumber(schedule.id);
                        origin = isOriginSchedule
                            ? schedule
                            : ((_c = (_b = schedule === null || schedule === void 0 ? void 0 : schedule.dateOption) === null || _b === void 0 ? void 0 : _b.repeat) === null || _c === void 0 ? void 0 : _c.origin) ||
                                ((_d = ScheduleQuery.getSchedulesFromCache()) === null || _d === void 0 ? void 0 : _d.find(function (item) { var _a, _b; return item.id === ((_b = (_a = schedule === null || schedule === void 0 ? void 0 : schedule.dateOption) === null || _a === void 0 ? void 0 : _a.repeat) === null || _b === void 0 ? void 0 : _b.originId); }));
                        if (!origin) {
                            notification.error({ message: '다시 한번 시도해주세요.' });
                            return [2 /*return*/, resolve(true)];
                        }
                        newSchedule = void 0;
                        if (radioValue === 'only' || radioValue === 'after') {
                            newSchedule =
                                // 첫 반복일정 이후 삭제일 경우 모든일정삭제와 같은 동작하도록
                                radioValue === 'after' && isOriginSchedule
                                    ? __assign(__assign({}, origin), { status: 'delete' }) : __assign(__assign({}, origin), { dateOption: __assign(__assign({}, origin.dateOption), { repeat: __assign(__assign({}, (_e = origin.dateOption) === null || _e === void 0 ? void 0 : _e.repeat), { expired: radioValue === 'only'
                                                ? (_g = (_f = origin.dateOption) === null || _f === void 0 ? void 0 : _f.repeat) === null || _g === void 0 ? void 0 : _g.expired
                                                : {
                                                    type: 'date',
                                                    endedAt: dayjs(schedule.dateOption.startedAt).subtract(1, 'hour').toDate()
                                                }, excludes: radioValue === 'only'
                                                ? (((_j = (_h = origin.dateOption) === null || _h === void 0 ? void 0 : _h.repeat) === null || _j === void 0 ? void 0 : _j.excludes) || []).concat({
                                                    startedAt: schedule.dateOption.startedAt,
                                                    endedAt: schedule.dateOption.endedAt
                                                })
                                                : ((_l = (_k = origin.dateOption) === null || _k === void 0 ? void 0 : _k.repeat) === null || _l === void 0 ? void 0 : _l.excludes) || [] }) }) });
                        }
                        else if (radioValue === 'all') {
                            newSchedule = __assign(__assign({}, origin), { status: 'delete' });
                        }
                        if (!newSchedule) return [3 /*break*/, 2];
                        return [4 /*yield*/, ScheduleQuery.updateOrDeleteSchedule(newSchedule)];
                    case 1:
                        _m.sent();
                        _m.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, ScheduleQuery.updateOrDeleteSchedule(__assign(__assign({}, schedule), { status: params.status }))];
                    case 4:
                        _m.sent();
                        _m.label = 5;
                    case 5:
                        if (shouldBlockNaver) {
                            syncNaverCalendar({
                                store: store,
                                effectedDates: [schedule.dateOption.startedAt]
                            });
                        }
                        notification.success({ message: "".concat(typeLabel, " \uBCC0\uACBD\uC644\uB8CC") });
                        return [3 /*break*/, 8];
                    case 6:
                        err_7 = _m.sent();
                        notification.error({ message: "".concat(typeLabel, " \uBCC0\uACBD \uC911 \uC5D0\uB7EC\uBC1C\uC0DD") });
                        return [3 /*break*/, 8];
                    case 7:
                        resolve(true);
                        modal.destroy();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        var modal = Modal.confirm({
            centered: true,
            title: "".concat(typeLabel, " \uC0AD\uC81C"),
            closable: true,
            okText: '삭제',
            zIndex: 9999,
            onOk: function () {
                deleteOrUpdate({ id: schedule.id, storeId: schedule.storeId, status: 'delete' });
            },
            cancelText: '아니요',
            content: (React.createElement("div", null,
                React.createElement(TextComponent, { children: "\uC0AD\uC81C\uD558\uC2E4 \uACBD\uC6B0 \uBCF5\uAD6C\uD558\uC2E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.", marginTop: 20, marginBottom: 5 }),
                schedule.isRepeatSchedule && (React.createElement("div", null,
                    React.createElement(Radio.Group, { defaultValue: 'only', onChange: function (e) {
                            radioValue = e.target.value;
                        } },
                        React.createElement(Space, { direction: "vertical" },
                            React.createElement(Radio, { value: "only" }, "\uC774 ".concat(typeLabel, "\uB9CC \uC0AD\uC81C")),
                            React.createElement(Radio, { value: "after" }, "\uC774 ".concat(typeLabel, " \uBC0F \uD5A5\uD6C4 \uBC18\uBCF5 ").concat(typeLabel, " \uC0AD\uC81C")),
                            React.createElement(Radio, { value: "all" }, "\uBAA8\uB4E0 \uBC18\uBCF5 ".concat(typeLabel, " \uC0AD\uC81C"))))))))
        });
    });
};
var MarginedIcon = styled(Icon)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
export var ScheduleBlock = function (props) {
    var _a, _b, _c;
    var schedule = props.schedule;
    var customer = schedule === null || schedule === void 0 ? void 0 : schedule.customer;
    var color = (_a = props.schedule) === null || _a === void 0 ? void 0 : _a.color;
    var hasDeposit = !!((_b = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _b === void 0 ? void 0 : _b.deposit);
    var isOnelineBlock = props.showTime;
    var isReservation = schedule.type === ScheduleModel.RESERVATION_TYPE.RESERVATION;
    var startTime = (_c = schedule.dateOption) === null || _c === void 0 ? void 0 : _c.startedAt;
    var renderAddition = function () {
        var _a;
        return isOnelineBlock ? (React.createElement("div", null)) : (React.createElement(React.Fragment, null, (_a = props.blockSettings) === null || _a === void 0 ? void 0 : _a.map(function (setting) {
            if (setting.type === 'scheduleProduct') {
                return React.createElement(TextComponent, { type: "caption1", children: schedule.displayContent, marginBottom: 1 });
            }
            if (setting.type === 'description' && schedule.isReservation) {
                return React.createElement(TextComponent, { type: "caption1", children: schedule.description, marginBottom: 1 });
            }
            if (setting.type === 'segment') {
                return (React.createElement(CustomerSegmentContainerInScheduleBlock, { items: CustomerQuery.getCustomerSegments(schedule.customer) }));
            }
        })));
    };
    var children = (React.createElement(ScheduleBlockWrapper, { className: props.className, isOnelineBlock: isOnelineBlock, managerColor: color.manager, statusColor: color.status, isReservation: isReservation },
        React.createElement(BlockRow, null,
            React.createElement(BlockPrepixer, { "$color": schedule.isReservation ? color.manager : COLORS.white }),
            React.createElement(FluidDiv, null,
                React.createElement(ScheduleBlockHeader, null,
                    isOnelineBlock && (React.createElement(TextComponent, { type: "caption1", marginRight: 5, children: dayjs(startTime).format('HH:mm') })),
                    React.createElement(NameLabel, { ellipsis: true, isOnelineBlock: isOnelineBlock, type: "subtitle3", marginRight: 5, children: !isReservation
                            ? schedule.name
                            : customer
                                ? "".concat(customer.name)
                                : schedule.customerId
                                    ? '삭제된 고객'
                                    : '미등록 고객' }),
                    React.createElement(ScheduleBlockIcons, null,
                        React.createElement(ScheduleIcon, { type: "provider", schedule: schedule }),
                        hasDeposit && React.createElement(ScheduleIcon, { type: "deposit", schedule: schedule }))),
                renderAddition()))));
    return props.disablePopover ? (children) : (React.createElement(ReservationStyledPopover, { content: React.createElement(ScheduleDetailForModal, __assign({}, props)) }, children));
};
var FluidDiv = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export var ScheduleBlockForMonth = React.memo(function (props) {
    var _a, _b, _c;
    var schedule = props.schedule;
    var customer = schedule === null || schedule === void 0 ? void 0 : schedule.customer;
    var color = (_a = props.schedule) === null || _a === void 0 ? void 0 : _a.color;
    var hasDeposit = !!((_b = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _b === void 0 ? void 0 : _b.deposit);
    var isReservation = schedule.type === ScheduleModel.RESERVATION_TYPE.RESERVATION;
    var startTime = (_c = schedule.dateOption) === null || _c === void 0 ? void 0 : _c.startedAt;
    var _d = useInView({
        threshold: 0
    }), ref = _d.ref, inView = _d.inView;
    var children = (React.createElement(ScheduleBlockWrapper, { className: props.className, isOnelineBlock: true, managerColor: color.manager, statusColor: color.status, isReservation: isReservation },
        React.createElement(BlockRow, null,
            React.createElement(BlockPrepixer, { "$color": schedule.isReservation ? color.manager : COLORS.white }),
            React.createElement(FluidDiv, null,
                React.createElement(ScheduleBlockHeader, null,
                    React.createElement(TextComponent, { type: "caption1", marginRight: 5, children: dayjs(startTime).format('HH:mm') }),
                    React.createElement(NameLabel, { ellipsis: true, isOnelineBlock: true, type: "subtitle3", marginRight: 5, children: !isReservation
                            ? schedule.name
                            : customer
                                ? "".concat(customer.name)
                                : schedule.customerId
                                    ? '삭제된 고객'
                                    : '미등록 고객' }),
                    React.createElement(ScheduleBlockIcons, null,
                        React.createElement(ScheduleIcon, { type: "provider", schedule: schedule }),
                        hasDeposit && React.createElement(ScheduleIcon, { type: "deposit", schedule: schedule })))))));
    return (React.createElement("div", { ref: ref }, !inView ? (React.createElement("div", { style: { width: '100%', height: '25px' } })) : (React.createElement(ReservationStyledPopover, { content: React.createElement(ScheduleDetailForModal, __assign({}, props)) }, children))));
}, function (prev, next) {
    var _a, _b;
    return prev.schedule.id === next.schedule.id && ((_a = prev.schedule) === null || _a === void 0 ? void 0 : _a.updatedAt) === ((_b = next.schedule) === null || _b === void 0 ? void 0 : _b.updatedAt);
});
export var ScheduleBlockForMobileMonth = React.memo(function (props) {
    var _a;
    var schedule = props.schedule;
    var customer = schedule === null || schedule === void 0 ? void 0 : schedule.customer;
    var color = (_a = props.schedule) === null || _a === void 0 ? void 0 : _a.color;
    var isReservation = schedule.type === ScheduleModel.RESERVATION_TYPE.RESERVATION;
    return (React.createElement(ScheduleBlockWrapper, { className: props.className, isOnelineBlock: true, managerColor: color.manager, statusColor: color.status, isReservation: isReservation },
        React.createElement(BlockRow, null,
            React.createElement(BlockPrepixer, { "$color": schedule.isReservation ? color.manager : COLORS.white }),
            React.createElement(ScheduleBlockHeader, null,
                React.createElement(TextComponent, { ellipsis: true, isOnelineBlock: true, type: "subtitle3", marginRight: 5, children: !isReservation
                        ? schedule.name
                        : customer
                            ? "".concat(customer.name)
                            : schedule.customerId
                                ? '삭제된 고객'
                                : '미등록 고객' })))));
}, function (prev, next) {
    var _a, _b;
    return prev.schedule.id === next.schedule.id && ((_a = prev.schedule) === null || _a === void 0 ? void 0 : _a.updatedAt) === ((_b = next.schedule) === null || _b === void 0 ? void 0 : _b.updatedAt);
});
var BlockPrepixer = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  width: ", "px;\n  min-width: ", "px;\n  background-color: ", ";\n  border-radius: 4px 0px 0px 4px;\n  margin-right: 2px;\n"], ["\n  width: ", "px;\n  min-width: ", "px;\n  background-color: ", ";\n  border-radius: 4px 0px 0px 4px;\n  margin-right: 2px;\n"])), function (props) { return (props.$color === COLORS.white ? 2 : 8); }, function (props) { return (props.$color === COLORS.white ? 2 : 8); }, function (props) { return props.$color; });
var BlockRow = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n"])));
export var ReservationStyledPopover = styled(Popover).attrs({
    overlayClassName: 'schedulePopover',
    zIndex: 99
})(templateObject_14 || (templateObject_14 = __makeTemplateObject([""], [""])));
export var ScheduleIcon = function (props) {
    var _a;
    var type = props.type, schedule = props.schedule;
    if (type === 'deposit') {
        var depositStatus = schedule.depositStatus;
        return React.createElement(ScheduleIconComponent, { iconName: depositStatus });
    }
    else {
        var prodiver = schedule.from || ((_a = schedule.data) === null || _a === void 0 ? void 0 : _a.provider) || 'crm';
        return React.createElement(ScheduleIconComponent, { iconName: prodiver });
    }
};
export var ScheduleIconComponent = function (props) {
    switch (props.iconName) {
        case 'naver':
            return React.createElement("img", { src: IMAGES.schedule_icon_naver });
        case 'crm':
            return React.createElement("img", { src: IMAGES.schedule_icon_thinkofyou });
        case 'pending':
            return React.createElement("img", { src: IMAGES.schedule_icon_deposit_pending });
        case 'completed':
            return React.createElement("img", { src: IMAGES.schedule_icon_deposit_complete });
        case 'over':
            return React.createElement("img", { src: IMAGES.schedule_icon_deposit_over });
        case 'under':
            return React.createElement("img", { src: IMAGES.schedule_icon_deposit_under });
        default:
            return React.createElement("div", null);
    }
};
export var ScheduleDepositWithLabel = function (props) {
    var _a, _b;
    var statusObject = {
        completed: {
            label: '입금완료',
            color: COLORS.info
        },
        under: {
            label: '입금부족',
            color: COLORS.calendarRedActive
        },
        over: {
            label: '입금초과',
            color: COLORS.calendarRedActive
        },
        pending: {
            label: '입금대기',
            color: COLORS.warning
        }
    };
    return (React.createElement(Row, { align: "middle" },
        React.createElement(ScheduleIconComponent, { iconName: props.type }),
        React.createElement(TextComponent, { type: "caption1", marginRight: 10, children: (_a = statusObject[props.type]) === null || _a === void 0 ? void 0 : _a.label, color: (_b = statusObject[props.type]) === null || _b === void 0 ? void 0 : _b.color })));
};
export var ScheduleSalesIcon = function () {
    return (React.createElement(SalesDiv, null,
        React.createElement("img", { src: IMAGES.schedule_icon_sales })));
};
var SalesDiv = styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  width: 14px;\n  height: 14px;\n  background-color: var(--primary-1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 14px;\n  height: 14px;\n  background-color: var(--primary-1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var ScheduleBlockWrapper = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  height: ", ";\n  width: 100%;\n  border-radius: 2px;\n  ", "\n  flex-wrap: norwap;\n"], ["\n  height: ", ";\n  width: 100%;\n  border-radius: 2px;\n  ", "\n  flex-wrap: norwap;\n"])), function (props) { return (props.isOnelineBlock ? '25px' : '100%'); }, function (props) {
    return props.isReservation
        ? css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n          border-top: 1px solid white;\n          border-bottom: 1px solid white;\n          background-color: ", ";\n        "], ["\n          border-top: 1px solid white;\n          border-bottom: 1px solid white;\n          background-color: ", ";\n        "])), props.statusColor) : css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n          border: solid 2px ", ";\n          background-color: ", ";\n        "], ["\n          border: solid 2px ", ";\n          background-color: ", ";\n        "])), props.managerColor, COLORS.white);
});
var NameLabel = styled(TextComponent)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  max-width: calc(100% - ", ");\n  // max-width: calc(100% - 35px);\n"], ["\n  max-width: calc(100% - ", ");\n  // max-width: calc(100% - 35px);\n"])), function (props) { return (props.isOnelineBlock ? '80px' : '50px'); });
var ScheduleBlockHeader = styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  display: flex;\n  align-items: start;\n  flex: 1;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: start;\n  flex: 1;\n  align-items: center;\n"])));
var ScheduleBlockIcons = styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  align-items: start;\n  & > img:not(last-child) {\n    margin-top: 2px;\n    margin-right: 2px;\n  }\n"], ["\n  flex: 1;\n  display: flex;\n  align-items: start;\n  & > img:not(last-child) {\n    margin-top: 2px;\n    margin-right: 2px;\n  }\n"])));
export var CalendarSetter = function () {
    var _a = useRecoilState(Atoms.calendarDisplaySelector), settings = _a[0], setSettings = _a[1];
    var handleChange = function (key, value) {
        var newValue = __assign({}, settings);
        newValue[key] = value;
        setOpenedTooltip(value.length > 0 ? key : null);
        setSettings(newValue);
    };
    var managers = ManagerQuery.getWorkingManagersInCache();
    var _b = React.useState(), opendTooltip = _b[0], setOpenedTooltip = _b[1];
    var filters = [
        {
            id: 'managerIds',
            label: '담당자',
            groups: [
                {
                    label: '담당자없음',
                    left: React.createElement(Rectangle, { color: COLORS.staff1, width: 12 }),
                    value: -1
                }
            ].concat(managers === null || managers === void 0 ? void 0 : managers.map(function (manager) {
                var _a;
                return {
                    label: manager.displayName,
                    value: manager.id,
                    left: React.createElement(Rectangle, { color: (_a = manager.profile) === null || _a === void 0 ? void 0 : _a.color, width: 12 })
                };
            }))
        },
        {
            id: 'types',
            label: '스케쥴',
            groups: [
                {
                    label: '예약',
                    value: ScheduleModel.RESERVATION_TYPE.RESERVATION,
                    items: [
                        { label: '예약대기', value: ScheduleModel.RESERVATION_STATUS.PENDING },
                        { label: '예약확정', value: ScheduleModel.RESERVATION_STATUS.CONFIRMED },
                        { label: '이용완료', value: ScheduleModel.RESERVATION_STATUS.COMPLETED },
                        { label: '매출등록', value: 'sales' },
                        { label: '노쇼', value: ScheduleModel.RESERVATION_STATUS.NOSHOW },
                        { label: '상점취소', value: ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE },
                        { label: '고객취소', value: ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR }
                    ]
                },
                {
                    value: ScheduleModel.RESERVATION_TYPE.SCHEDULE,
                    label: '일정'
                },
                {
                    value: ScheduleModel.RESERVATION_TYPE.OFF,
                    label: '휴무'
                }
            ]
        },
        {
            id: 'provider',
            label: '등록경로',
            groups: [
                { left: React.createElement(ScheduleIconComponent, { iconName: "naver" }), label: '네이버 예약', value: 'naver' },
                { left: React.createElement(ScheduleIconComponent, { iconName: "crm" }), label: '직접 등록', value: 'crm' }
            ]
        },
        {
            id: 'deposits',
            label: '예약금',
            groups: [
                { label: '예약금 없음', value: 'none' },
                { left: React.createElement(ScheduleIconComponent, { iconName: "pending" }), label: '예약금 있음 - 입금대기', value: 'pending' },
                {
                    left: React.createElement(ScheduleIconComponent, { iconName: "completed" }),
                    label: '예약금 있음 - 입금완료',
                    value: 'completed'
                },
                {
                    left: React.createElement(ScheduleIconComponent, { iconName: "over" }),
                    label: '예약금 있음 - 입금초과',
                    value: 'over'
                },
                {
                    left: React.createElement(ScheduleIconComponent, { iconName: "under" }),
                    label: '예약금 있음 - 입금부족',
                    value: 'under'
                }
            ]
        }
    ];
    return (React.createElement(Row, { wrap: false, justify: "end", style: { paddingRight: '20px' } },
        filters.map(function (filter) {
            return (React.createElement(CheckboxDropdownContent, __assign({}, filter, { open: true, key: filter.id, onCloseTooltip: function () { return setOpenedTooltip(null); }, tooltipOpen: opendTooltip === filter.id, values: settings[filter.id], onChange: function (values) {
                    handleChange(filter.id, values);
                } })));
        }),
        React.createElement(Dropdown, { trigger: ['click'], children: React.createElement(AntLeftIconButton, { size: "small", children: "\uC140\uB192\uC774", icon: React.createElement(Icon, { name: "down-chevron" }) }), dropdownRender: function () { return (React.createElement(DropdownOverlayWrapper, null,
                React.createElement(CellHeightSlider, { value: settings.magnification, onChange: handleChange }))); } })));
};
export var LabelWithDropdown = function (props) {
    return (React.createElement(SearchControllerCol, { onClick: function (ev) {
            var onClick = props.onClick;
            if (onClick) {
                onClick(ev);
            }
        } },
        React.createElement(TextComponent, { children: props.label, color: props.color || COLORS.black }),
        React.createElement(Icon, { name: "down-chevron" })));
};
export var SearchControllerCol = styled(Col)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  width: auto;\n  height: 40px;\n  align-items: center;\n  margin-right: 5px;\n"], ["\n  display: flex;\n  cursor: pointer;\n  width: auto;\n  height: 40px;\n  align-items: center;\n  margin-right: 5px;\n"])));
var DropdownOverlayWrapper = styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  border-radius: 4px;\n  border: solid 1px var(--gray-6);\n  background-color: ", ";\n  padding: 10px;\n  // & li {\n  //   height: 32px !important;\n  //   align-items: center;\n  //   display: flex;\n  // }\n  // & .ant-menu-item-selected {\n  //   background-color: ", " !important;\n\n  //   &:hover {\n  //     ", "\n  //   }\n  // }\n"], ["\n  border-radius: 4px;\n  border: solid 1px var(--gray-6);\n  background-color: ", ";\n  padding: 10px;\n  // & li {\n  //   height: 32px !important;\n  //   align-items: center;\n  //   display: flex;\n  // }\n  // & .ant-menu-item-selected {\n  //   background-color: ", " !important;\n\n  //   &:hover {\n  //     ", "\n  //   }\n  // }\n"])), COLORS.white, COLORS.white, COLORS.primaryFocus);
var CellHeightSlider = function (props) {
    var step = 10;
    return (React.createElement(Row, { align: "middle" },
        React.createElement(StyledIcon, { name: "minus", color: COLORS.white, size: 14, onClick: function () {
                if (props.value > 50) {
                    props.onChange('magnification', props.value - step);
                }
            } }),
        React.createElement(Slider, { min: 50, max: 200, step: step, value: props.value || 100, style: { width: '120px' }, onChange: function (value) {
                props.onChange('magnification', value);
            } }),
        React.createElement(StyledIcon, { name: "plus", color: COLORS.white, size: 14, onClick: function () {
                if (props.value < 200) {
                    props.onChange('magnification', props.value + step);
                }
            } })));
};
var StyledIcon = styled(Icon)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  padding: 2px;\n  background-color: ", ";\n  border-radius: 2px;\n  cursor: pointer;\n"], ["\n  padding: 2px;\n  background-color: ", ";\n  border-radius: 2px;\n  cursor: pointer;\n"])), COLORS.primary1);
var DeleteDiv = styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  cursor: pointer;\n\n  & > svg {\n    margin-left: 10px;\n  }\n"], ["\n  cursor: pointer;\n\n  & > svg {\n    margin-left: 10px;\n  }\n"])));
export var DepositStatusLabel = function (props) {
    var values = {
        pending: {
            icon: IMAGES.schedule_icon_deposit_pending,
            color: COLORS.warning,
            text: '입금대기'
        },
        completed: {
            icon: IMAGES.schedule_icon_deposit_complete,
            color: COLORS.info,
            text: '입금완료'
        },
        over: {
            icon: IMAGES.schedule_icon_deposit_over,
            color: COLORS.calendarRedActive,
            text: '입금초과'
        },
        under: {
            icon: IMAGES.schedule_icon_deposit_under,
            color: COLORS.calendarRedActive,
            text: '입금부족'
        }
    };
    var value = values[props.status];
    return value ? (React.createElement(Row, { align: "middle", className: props.className, onClick: props.onClick },
        React.createElement("img", { src: value.icon }),
        React.createElement(TextComponent, { children: "".concat(value.text, " >"), marginLeft: 5, color: value.color }))) : null;
};
export var ScheduleCard = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var schedule = props.schedule;
    var customerName = ((_a = schedule === null || schedule === void 0 ? void 0 : schedule.customer) === null || _a === void 0 ? void 0 : _a.name) || '미등록 고객';
    var phone = ((_b = schedule === null || schedule === void 0 ? void 0 : schedule.customer) === null || _b === void 0 ? void 0 : _b.phoneToString) || ((_c = schedule === null || schedule === void 0 ? void 0 : schedule.customer) === null || _c === void 0 ? void 0 : _c.phone) || '';
    var isNaver = ((_d = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _d === void 0 ? void 0 : _d.provider) === 'naver';
    var deposit = (_e = schedule === null || schedule === void 0 ? void 0 : schedule.data) === null || _e === void 0 ? void 0 : _e.deposit;
    var items = [ScheduleModel.RESERVATION_STATUS.PENDING, ScheduleModel.RESERVATION_STATUS.CONFIRMED];
    return (React.createElement(ScheduleCardWrapper, { gutter: 8 },
        React.createElement(TextComponent, { children: dayjs(schedule.dateOption.startedAt).format(DATE_FORMAT_INCLUDE_TIME_AAA), type: "caption1" }),
        React.createElement(TextComponent, { children: "".concat(customerName, " ").concat(phone ? "(".concat(phone, ")") : ''), type: "headline3" }),
        React.createElement(Layout.Inline, { gutter: 8 },
            React.createElement(Layout.Inline, { align: "center", gutter: 4 },
                React.createElement(ScheduleIcon, { type: "provider", schedule: schedule }),
                React.createElement(TextComponent, { children: isNaver ? '네이버' : '직접입력', type: "caption1", marginLeft: 5 })),
            React.createElement(Layout.Inline, { align: "center", gutter: 4 },
                React.createElement(ScheduleIcon, { type: "deposit", schedule: schedule }),
                React.createElement(TextComponent, { children: KRWFomatToString({ value: deposit }), type: "caption1", marginLeft: 5 })),
            React.createElement(Layout.Inline, { align: "center", gutter: 4 },
                React.createElement(Rectangle, { color: (_f = schedule.manager) === null || _f === void 0 ? void 0 : _f.color, width: 12 }),
                React.createElement(TextComponent, { children: schedule.managerName, type: "caption1", marginLeft: 5 }))),
        props.onChange && (React.createElement(Layout.Inline, { align: "center", gutter: 4 },
            React.createElement(Radio.Group, { onChange: props.onChange, value: schedule.status }, items.map(function (item) {
                return (React.createElement(Radio, { key: item, children: React.createElement(ScheduleStatusTag, { schedule: { status: item } }), value: item }));
            }))))));
};
export var ScheduleCardWrapper = styled(Layout.Stack)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  margin-top: 20px;\n  width: 100%;\n  padding: 7px 15px;\n  border-radius: 2px;\n  border: solid 1px ", ";\n  background-color: ", ";\n"], ["\n  margin-top: 20px;\n  width: 100%;\n  padding: 7px 15px;\n  border-radius: 2px;\n  border: solid 1px ", ";\n  background-color: ", ";\n"])), COLORS.gray6, COLORS.white);
export var NaverPayCollapse = function (props) {
    var _a, _b;
    var _c = props.result || {}, pre = _c.pre, post = _c.post;
    var prePaidAmount = pre ? (['PAID', 'COMPLETED', 'REFUNDED'].includes(pre.status) && pre.amount) || 0 : 0;
    var postPaidAmount = post ? (['PAID', 'COMPLETED', 'REFUNDED'].includes(post.status) && post.amount) || 0 : 0;
    var totalPaid = postPaidAmount + prePaidAmount;
    var totalRefunded = ((pre === null || pre === void 0 ? void 0 : pre.refundedAmount) || 0) + ((post === null || post === void 0 ? void 0 : post.refundedAmount) || 0);
    var total = totalPaid - totalRefunded;
    var renderItem = function (data, label) {
        return (React.createElement("div", { style: { marginTop: '5px' } },
            React.createElement(TextComponent, { children: "".concat(label, "(").concat(NAVER_PAY_STATUS[data.status], ")"), type: "headline3" }), data === null || data === void 0 ? void 0 :
            data.items.map(function (item, index) {
                return (React.createElement(Row, { key: "".concat(label, "_").concat(index), justify: "space-between" },
                    React.createElement(TextComponent, { children: item.name, color: COLORS.gray3 }),
                    React.createElement(TextComponent, { children: KRWFomatToString({ value: item.price }) })));
            })));
    };
    var WEEKS = {
        MONDAY: '월',
        TUESDAY: '화',
        WEDNESDAY: '수',
        THURSDAY: '목',
        FRIDAY: '금',
        SATURDAY: '토',
        SUNDAY: '일'
    };
    var renderCoupon = function (coupons) {
        var couponTypes = function (type, infos) {
            var _a;
            if (!(infos === null || infos === void 0 ? void 0 : infos.discountValue) && !(infos === null || infos === void 0 ? void 0 : infos.menuTitle)) {
                return '혜택 없음';
            }
            var objec = {
                DISCOUNT_TOTAL_AMOUNT_BY_AMOUNT: {
                    label: '전체 결제금액 정액 할인',
                    value: "\uC804\uCCB4 \uACB0\uC81C\uAE08\uC561\uC5D0\uC11C ".concat(infos.discountValue, "\uC6D0 \uD560\uC778")
                },
                DISCOUNT_TOTAL_AMOUNT_BY_RATE: {
                    label: '전체 결제금액 정률 할인',
                    value: "\uC804\uCCB4 \uACB0\uC81C\uAE08\uC561\uC5D0\uC11C ".concat(infos.discountValue, "% \uD560\uC778")
                },
                GIFT: {
                    label: '증정',
                    value: "".concat(infos.menuTitle, " \uC99D\uC815")
                }
            };
            return (_a = objec[type]) === null || _a === void 0 ? void 0 : _a.value;
        };
        return (React.createElement("div", null,
            React.createElement(Divider, null),
            React.createElement(ColorTag, { children: "\uB124\uC774\uBC84 \uCFE0\uD3F0 \uC0AC\uC6A9\uC815\uBCF4", color: COLORS.info }),
            React.createElement(TextComponent, { marginTop: 5, marginBottom: 5, children: "\uACE0\uAC1D\uB2D8\uC774 \uC0AC\uC6A9\uD558\uACE0\uC790 \uC120\uD0DD\uD558\uC2E0 \uCFE0\uD3F0\uC785\uB2C8\uB2E4. \uC544\uB798 \uB0B4\uC6A9\uC744 \uCC38\uACE0\uD558\uC5EC \uACC4\uC0B0\uC5D0 \uC801\uC6A9\uD574\uC8FC\uC138\uC694.", type: "headline3" }),
            coupons.map(function (coupon) {
                var _a, _b, _c, _d, _e, _f;
                var couponDiscountInfos = coupon.couponDiscountInfos;
                var couponUseTypes = {
                    ALL: '예약/주문/현장 모두 사용',
                    BOOKING: '예약에서만 사용',
                    ORDER: '주문에서만 사용'
                };
                var couponUseConditionInfo = coupon.couponUseConditionInfo;
                return (React.createElement("div", { key: coupon.userCouponCode },
                    React.createElement(Row, { justify: "space-between", style: { marginBottom: 10 } },
                        React.createElement(Col, null,
                            React.createElement(TextComponent, { children: "\uCFE0\uD3F0\uBC88\uD638", color: COLORS.gray3 })),
                        React.createElement(Col, null,
                            React.createElement(TextComponent, { children: coupon.userCouponCode }))),
                    React.createElement(Row, { justify: "space-between", style: { marginBottom: 10 } },
                        React.createElement(Col, null,
                            React.createElement(TextComponent, { children: "\uCFE0\uD3F0\uD61C\uD0DD", color: COLORS.gray3 })),
                        React.createElement(Col, null, couponDiscountInfos === null || couponDiscountInfos === void 0 ? void 0 : couponDiscountInfos.map(function (couponInfo, index) {
                            return (React.createElement(Row, { key: "discount_".concat(index) },
                                React.createElement(TextComponent, { children: couponTypes(coupon.couponType, couponInfo) })));
                        }))),
                    React.createElement(Row, { justify: "space-between" },
                        React.createElement(Col, null,
                            React.createElement(TextComponent, { children: "\uCFE0\uD3F0 \uC0AC\uC6A9\uC81C\uD55C", color: COLORS.gray3 })),
                        React.createElement(Col, null,
                            React.createElement(Row, { justify: "start" },
                                React.createElement(Col, null,
                                    React.createElement(TextComponent, { children: "\uCD5C\uC18C\uC774\uC6A9\uAE08\uC561 :  ".concat((couponUseConditionInfo === null || couponUseConditionInfo === void 0 ? void 0 : couponUseConditionInfo.minimumPaymentPrice)
                                            ? KRWFomatToString({ value: couponUseConditionInfo === null || couponUseConditionInfo === void 0 ? void 0 : couponUseConditionInfo.minimumPaymentPrice })
                                            : '제한없음') }))),
                            React.createElement(Row, { justify: "start" },
                                React.createElement(Col, null,
                                    React.createElement(TextComponent, { children: "\uC0AC\uC6A9\uAC00\uB2A5\uC2DC\uAC04 : ".concat((couponUseConditionInfo === null || couponUseConditionInfo === void 0 ? void 0 : couponUseConditionInfo.usableTime)
                                            ? [
                                                (_b = (_a = couponUseConditionInfo === null || couponUseConditionInfo === void 0 ? void 0 : couponUseConditionInfo.usableTime) === null || _a === void 0 ? void 0 : _a.weekdays) === null || _b === void 0 ? void 0 : _b.map(function (weekdays) { return WEEKS[weekdays]; }).join(','),
                                                [
                                                    (_d = (_c = couponUseConditionInfo === null || couponUseConditionInfo === void 0 ? void 0 : couponUseConditionInfo.usableTime) === null || _c === void 0 ? void 0 : _c.time) === null || _d === void 0 ? void 0 : _d.start,
                                                    (_f = (_e = couponUseConditionInfo === null || couponUseConditionInfo === void 0 ? void 0 : couponUseConditionInfo.usableTime) === null || _e === void 0 ? void 0 : _e.time) === null || _f === void 0 ? void 0 : _f.end
                                                ]
                                                    .filter(Boolean)
                                                    .join('~')
                                            ]
                                                .filter(Boolean)
                                                .join(' / ')
                                            : '제한없음') }))),
                            React.createElement(Row, { justify: "start" },
                                React.createElement(Col, null,
                                    React.createElement(TextComponent, { children: dayjs(coupon === null || coupon === void 0 ? void 0 : coupon.startDateTime).year() === 2000
                                            ? "\uC720\uD6A8\uAE30\uAC04 : \uC81C\uD55C \uC5C6\uC74C"
                                            : "\uC720\uD6A8\uAE30\uAC04 : ".concat(!(coupon === null || coupon === void 0 ? void 0 : coupon.startDateTime) && !(coupon === null || coupon === void 0 ? void 0 : coupon.endDateTime)
                                                ? '제한없음'
                                                : (coupon === null || coupon === void 0 ? void 0 : coupon.startDateTime)
                                                    ? dayjs(coupon.startDateTime).format(DATE_FORMAT_INCLUDE_TIME)
                                                    : '', " ~ ").concat((coupon === null || coupon === void 0 ? void 0 : coupon.endDateTime) ? dayjs(coupon.endDateTime).format(DATE_FORMAT_INCLUDE_TIME) : '') }))),
                            React.createElement(Row, { justify: "start" },
                                React.createElement(Col, null,
                                    React.createElement(TextComponent, { children: "\uC9C1\uC811\uC785\uB825\uC870\uAC74 : ".concat((couponUseConditionInfo === null || couponUseConditionInfo === void 0 ? void 0 : couponUseConditionInfo.otherCondition) || '-') })))))));
            })));
    };
    return (React.createElement(Collapse, { defaultActiveKey: ['1'], size: "small" },
        React.createElement(Collapse.Panel, { header: React.createElement(Row, null,
                React.createElement("img", { src: IMAGES.schedule_icon_naver }),
                React.createElement(TextComponent, { children: "\uB124\uC774\uBC84\uD398\uC774 \uACB0\uC81C\uB0B4\uC5ED", marginLeft: 5 })), key: "1" },
            React.createElement(React.Fragment, null,
                React.createElement(Row, { justify: "space-between" },
                    React.createElement(TextComponent, { children: "\uACB0\uC81C\uAE08\uC561", type: "headline3" }),
                    React.createElement(TextComponent, { children: KRWFomatToString({ value: totalPaid }), type: "headline3" })),
                React.createElement(Row, { justify: "space-between" },
                    React.createElement(TextComponent, { children: "\uD658\uBD88\uAE08\uC561", type: "headline3" }),
                    React.createElement(TextComponent, { children: KRWFomatToString({ value: totalRefunded }), type: "headline3" })),
                React.createElement(Divider, null),
                React.createElement(Row, { justify: "space-between" },
                    React.createElement(TextComponent, { children: "\uACB0\uC81C \uCD1D\uC561", type: "headline3" }),
                    React.createElement(TextComponent, { children: KRWFomatToString({ value: total }), type: "headline3" }))),
            !isEmpty((_a = props.result) === null || _a === void 0 ? void 0 : _a.coupons) ? props.isBookingFee ? React.createElement("div", null) : renderCoupon((_b = props.result) === null || _b === void 0 ? void 0 : _b.coupons) : React.createElement("div", null))));
};
var ViewSalesButton = function (props) {
    return (React.createElement(ClickableText, { color: COLORS.primary1, children: "\uB4F1\uB85D\uB41C \uB9E4\uCD9C\uBCF4\uAE30 >", onClick: props.onClick, style: { paddingRight: '5px', paddingLeft: '5px', paddingTop: '5px' } }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;
